import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Container,
  Form,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";
import * as Cookies from "es-cookie";
import { canView, canEdit, canDelete } from "../../../utils/modulePermissions";
import { Scrollbars } from "react-custom-scrollbars";
import SelectBoxWithDisabledOption from "../selectdropdown/SelectBoxWithDisabledOption";
import CardLessDataTable from "../../../neetjee_guru/components/datatables/CardLessDataTableWithSearch";
import QuestionSelectedDetails from "./QuestionSelectedDetails";
import ExamMadeEasyModal from "./ExamMadeEasyModal";
import { components } from "react-select";
import MultiSelect from "react-multi-select-component";
import "./_exam_made_easy.scss";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import parse, { domToReact } from "html-react-parser";
import moment from "moment";
import { scroller } from "react-scroll";
import AdaptiveExams from "../adaptiveExams/AdaptiveExams";
import PdfTabs from "../PDFUpload/Pdf_upload_list";

const GROUPEXAMMADEEASY_PAPER = gql`
  mutation (
    $params: ExamMadeEasyPaper
    $time_duration: Int
    $question_count: [SubjectQuestionCount]
  ) {
    createExamMadeEasyPaper(
      params: $params
      time_duration: $time_duration
      question_count: $question_count
    ) {
      filename
      exam_paper_id
      exam_questions {
        id
        subject
        chapter
        question
        option1
        option2
        option3
        option4
        qtype
        compquestion
        list1type
        list2type
        mat_question
        answer
        inputquestion
        chapter_name
      }
    }
  }
`;

const GROUPEXAMMADEEASY_DRAFT_PAPER = gql`
  mutation (
    $params: ExamMadeEasyPaper
    $time_duration: Int
    $question_count: [SubjectQuestionCount]
  ) {
    examMadeEasyDraftPapers(
      params: $params
      time_duration: $time_duration
      question_count: $question_count
    ) {
      filename
      exam_paper_id
      exam_questions {
        id
        subject
        chapter
        question
        option1
        option2
        option3
        option4
        qtype
        compquestion
        list1type
        list2type
        mat_question
        answer
        inputquestion
        chapter_name
      }
    }
  }
`;

// Role permissions for this module. The grant row is
//   { module_key: "Exam_Made_Easy", module_name: "Online Exams", is_view, is_edit, is_delete }
//
// Match on module_key ONLY — never on module_name. "Online Exams" is the sidebar
// GROUP that Exam_Made_Easy, Manage_Exams, Quiz and View_Results all share, so
// accepting it here would also match those siblings' rows; can() allows an action
// when ANY matched row grants it, so a role with edit on Manage_Exams would silently
// inherit edit on Exam Made Easy. module_key is unique per module (it's what the
// sidebar keys off — see buildModuleVisibility).
const EXAM_MADE_EASY_MODULE = ["Exam_Made_Easy"];

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    width: "3px",
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};
const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg
          height="20"
          width="20"
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
          className="css-6q0nyr-Svg"
        >
          <path
            fill="currentColor"
            d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
          ></path>
        </svg>
      </components.DropdownIndicator>
    )
  );
};
class CreateExamMadeEasy extends Component {
  constructor(props) {
    super(props);
    let clsdata = props.globals.classes.map((item) => {
      if (item.id == "1") {
        return { ...item, active: "outline-secondary active" };
      }
      return { ...item, active: "outline-secondary" };
    });
    this.state = {
      exam_name: "",
      exam_type: "0",
      exam_typeValue: "",
      class_id: "0",
      classvalue: "",
      generate_type: "1",
      pattern_type: "0",
      subjects: [],
      classData: clsdata,
      syllabusclass: "1",
      qbQuestionSearchSubject: "",
      qbsearchsubject: "0",
      qbsearchsubjectvalue: "",
      qbsearchchapter: "0",
      qbsearchchaptervalue: "",
      qbsearchtopic: [],
      qbsearchtopicvalue: [],
      typeOfQuestion: "0",
      typeOfQuestionvalue: "",
      complexity: "0",
      complexityvalue: "",
      subjectOptions: [],
      getChaptersArr: [],
      getTopicsArr: [],
      getTypeOfQuestionsArr: [],
      getComplexityValueArr: [],
      getQuestionBankQuestions: "",
      validateSubject: "",
      validateChapter: "",
      validateTopic: "",
      validateTypeOfQuestion: "",
      validateComplexity: "",
      validateExamType: "",
      checkedVall: false,
      activePage: 1,
      totalItemsCount: 0,
      itemsCountPerPage: 10,
      showSpinner: "hide",
      otherexam: "",
      noofsets: "1",
      startdate: "",
      enddate: "",
      currentStep: 1,
      getSectionsArr: [],
      branchSelected: [],
      sectionSelected: [],
      sectionSelectedvalue: [],
      generalQuestionsBotanySelected: [],
      generalQuestionsZoologySelected: [],
      generalQuestionsPhysicsSelected: [],
      generalQuestionsChemistrySelected: [],
      generalQuestionsMathsSelected: [],
      integerQuestionsBotanySelected: [],
      integerQuestionsZoologySelected: [],
      integerQuestionsPhysicsSelected: [],
      integerQuestionsChemistrySelected: [],
      integerQuestionsMathsSelected: [],
      generalQuestionsBiologySelected: [],

      generalQuestionsCount: 0,
      integerQuestionCount: 0,
      complexity_type_str: "easy",
      custom_easy_val: "",
      custom_modarate_val: "",
      custom_difficult_val: "",
      validateCustomInputValues: "",
      modalShow: false,
      submitError1: "",
      paper_generate_type: "",
      examTypeOptions: [],
      timeduration: 90,
      formErrors: {
        exam_type: "",
        branch: "",
        class: "",
        section: "",
        exam_name: "",
        timeduration: "",
      },
      questionbank_checked: false,
      owedqfilterclass: "1",
      easy_easy: 0,
      easy_Modarate: 0,
      easy_block_Difficult: 0,
      standard_easy: 0,
      standard_block_Modarate: 0,
      standard_block_Difficult: 0,
      paginationShowBlock: "",
      exam_generate_class_value: "1",
      exam_generate_class: { value: "1", label: "XI" },

      getGenerateTypes: [
        { value: "group_custom", label: "Custom" },
        { value: "group_semi_grand", label: "Semi Grand" },
        { value: "group_grand", label: "Grand" },
      ],
      exam_generate_type: "group_custom",
      exam_generate_type_value: { value: "group_custom", label: "Custom" },
      add3Hours_val: "",
      showQuestionsNotAvailable: "yes",
      qbsearchsubjectError: "",
      isSubmitting: false,

      exam_mode: 0,
      getScheduledTypesArr: [],
      scheduledSubType_id: 0,
      scheduledSubTypeValue: "",

      activeTab: 1,

      // Shown when a role without is_edit / is_delete tries to act.
      accessDeniedShow: false,
    };
  }

  // ── Role-based access control ───────────────────────────────────────────────
  // is_view gates the page itself (render falls through to an Access Denied card).
  // is_edit gates every write: opening the create modal, submitting it, and the two
  // paper mutations. is_delete gates removal.
  // Admins (userlevel 1/2) and roles with no configured grants keep full access —
  // see can() in utils/modulePermissions.
  //
  // The buttons stay VISIBLE for a view-only role; clicking one opens the Access
  // Denied modal instead of the form. The mutations re-check independently, so a
  // stale render or a devtools-forced click still can't write.
  canViewExams = () => canView(EXAM_MADE_EASY_MODULE);
  canEditExams = () => canEdit(EXAM_MADE_EASY_MODULE);
  canDeleteExams = () => canDelete(EXAM_MADE_EASY_MODULE);

  showAccessDenied = () => this.setState({ accessDeniedShow: true });
  hideAccessDenied = () => this.setState({ accessDeniedShow: false });

  // Guards for the two write classes. Each returns false and pops the Access Denied
  // modal when the grant is missing, so callers read as: `if (!this.requireEdit()) return;`
  requireEdit = () => {
    if (this.canEditExams()) return true;
    this.showAccessDenied();
    return false;
  };

  requireDelete = () => {
    if (this.canDeleteExams()) return true;
    this.showAccessDenied();
    return false;
  };

  // Navigation that respects the grant. "Create College Exams" and "Show Draft
  // Papers" used to be <Link>s, so react-router navigated on click before any
  // permission check could run — a view-only role was redirected into the create /
  // draft workspace instead of being stopped. Routing them through here keeps the
  // user on the page and shows the Access Denied modal instead of redirecting.
  // Plain buttons, not anchors: an <a href> could still be middle-clicked or
  // opened in a new tab, which would skip the check entirely.
  navigateIfEditAllowed = (path) => {
    if (!this.requireEdit()) return;
    this.props.history.push(path);
  };

  componentDidMount() {
    this.datefunction();
    let easy_easyVal = 0;
    let easy_modarateVal = 0;
    let easy_difficultVal = 0;
    let standard_easyVal = 0;
    let standard_modarateVal = 0;
    let standard_difficultVal = 0;
    let defaultExamTypeId = this.props.globals.exams[0];

    //console.log("exam_typeValue", defaultExamTypeId)
    this.setState({
      exam_typeValue: {
        value: defaultExamTypeId.id,
        label: defaultExamTypeId.exam,
      },
      exam_type: defaultExamTypeId.id,
    });
    setTimeout(() => {
      //console.log("exam_typeValue", this.state.exam_typeValue)

      let examsData = this.props.globals.exams.find(
        (a) => a.id == this.state.exam_typeValue.value,
      );
      let examsubjectData = examsData.exam_subjects;
      let subjects = [];
      let subjectOptionsArr = [];
      let pattern_type =
        (this.state.exam_typeValue.value == "3" ||
          this.state.exam_typeValue.value == "6" ||
          this.state.exam_typeValue.value == "7" ||
          this.state.exam_typeValue.value == "8") &&
          this.state.exam_generate_type == "group_custom"
          ? 3
          : 0;
      // newcodeend
      for (let i = 0; i <= examsubjectData.length; i++) {
        let idata = examsubjectData[i];
        //console.log("idata", idata);
        if (idata != undefined) {
          let subjectData = this.props.globals.subjects.find(
            (a) => a.id == idata.subject_id,
          );
          // //console.log("subjectData", subjectData);

          let chapters = [];
          if (
            this.state.exam_type == "3" ||
            this.state.exam_type == "6" ||
            this.state.exam_type == "7" ||
            this.state.exam_type == "8"
          ) {
            chapters = subjectData.state_chapters
              .filter(
                (item1) =>
                  parseInt(item1.exam_id) == parseInt(this.state.exam_type),
              )
              .map((item) => {
                //console.log("subjectDatassss", chapters);
                const topic = item.state_topics.map((topicData) => {
                  return { ...topicData, checked: false };
                });

                return {
                  ...item,
                  topics: topic,
                  chapteractive:
                    "d-flex justify-content-between align-items-center",
                  checked: false,
                  checkedall: false,
                  ownedarray: [],
                  questionbarray: [],
                };
              });
          } else {
            chapters = subjectData.chapters.map((item) => {
              //console.log("subjectData", subjectData);
              const topic = item.topics.map((topicData) => {
                return { ...topicData, checked: false };
              });

              return {
                ...item,
                topics: topic,
                chapteractive:
                  "d-flex justify-content-between align-items-center",
                checked: false,
                checkedall: false,
                ownedarray: [],
                questionbarray: [],
              };
            });
          }

          /*let chapters = subjectData.chapters.map((item) => {
                        //console.log("subjectData", subjectData);
                        const topic = item.topics.map((topicData) => {
                            return { ...topicData, checked: false }
                        })
    
                        return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                    })*/

          let questions_count =
            (this.state.exam_typeValue.value == "3" ||
              this.state.exam_typeValue.value == "6" ||
              this.state.exam_typeValue.value == "7" ||
              this.state.exam_typeValue.value == "8") &&
              this.state.exam_generate_type == "group_custom"
              ? 0
              : idata.no_of_questions;

          const newObject = {
            id: subjectData.id,
            subject: subjectData.subject,
            chapters: chapters,
            checked: false,
            subjectactive: "d-flex justify-content-between align-items-center",
            qcount: questions_count,
            totError: "",
          };
          const newObj = {
            value: subjectData.id,
            label: subjectData.subject,
          };
          subjects.push(newObject);
          subjectOptionsArr.push(newObj);
        }
      }
      let examTypeArr = [];
      this.props.globals.exams.map((item) => {
        const newObj1 = {
          value: item.id,
          label: item.exam,
        };
        examTypeArr.push(newObj1);
      });

      //console.log("ssss", examTypeArr)

      let questionTypeArr = [];
      this.props.globals.questionTypes.map((item) => {
        if (this.state.exam_type != "2") {
          if (item.id == 7) {
            const newObj1 = {
              value: item.id,
              label: item.questiontype,
            };
            questionTypeArr.push(newObj1);
          }
        } else {
          if (item.id == 7 || item.id == 8) {
            const newObj1 = {
              value: item.id,
              label: item.questiontype,
            };
            questionTypeArr.push(newObj1);
          }
        }
      });
      let complexityArr = [];
      this.props.globals.complexity.map((item) => {
        if (item.id != 5) {
          const newObj2 = {
            value: item.id,
            label: item.complexity,
          };
          complexityArr.push(newObj2);
        }
      });

      let sectionsArr = [];
      for (let i = 0; i <= this.props.globals.globalSections.length; i++) {
        let idata = this.props.globals.globalSections[i];
        if (idata != undefined) {
          if (this.state.exam_type == idata.exam_id) {
            const newObj = {
              value: idata.id,
              label: idata.section_name,
              branch: idata.branch_id,
            };
            sectionsArr.push(newObj);
          }
        }
      }

      if (this.props?.getExamStandardPercentage) {
        this.props.getExamStandardPercentage.forEach((item) => {
          if (item?.type_of_exam == "Easy") {
            if (this.state?.exam_type == item.exam_id) {
              easy_easyVal = item.easy;
              easy_modarateVal = item.moderate;
              easy_difficultVal = item.difficult;
            }
          } else {
            if (this.state.exam_type == item.exam_id) {
              standard_easyVal = item.easy;
              standard_modarateVal = item.moderate;
              standard_difficultVal = item.difficult;
            }
          }
        });
      }

      let scheduledNamesArr = [];
      for (
        let i = 0;
        i <= this.props?.getExamScheduleSubTypeQuestions?.length;
        i++
      ) {
        let idata = this.props.getExamScheduleSubTypeQuestions[i];
        if (idata != undefined) {
          const newObj = {
            value: idata.schedule_sub_type_id,
            label: idata.schedule_sub_type,
            schedule_type_id: idata.schedule_type_id,
            adaptive_type_id: idata.adaptive_type_id,
          };
          scheduledNamesArr.push(newObj);
        }
      }

      this.setState({
        subjects: subjects,
        pattern_type: pattern_type,
        subjectOptions: subjectOptionsArr,
        getTypeOfQuestionsArr: questionTypeArr,
        getComplexityValueArr: complexityArr,
        getSectionsArr: sectionsArr,
        examTypeOptions: examTypeArr,
        easy_easy: easy_easyVal,
        easy_Modarate: easy_modarateVal,
        easy_block_Difficult: easy_difficultVal,
        standard_easy: standard_easyVal,
        standard_block_Modarate: standard_modarateVal,
        standard_block_Difficult: standard_difficultVal,
        getScheduledTypesArr: scheduledNamesArr,
      });
    }, 1000);
  }
  getChapters = () => {
    //console.log("aravind", this.state.subjects)
    let getArray = [];
    for (let i = 0; i <= this.state.subjects.length; i++) {
      let idata = this.state.subjects[i];
      if (idata != undefined) {
        //console.log("aravind", idata.id)
        //console.log("aravind", this.state.qbsearchsubject)
        if (idata.id == this.state.qbsearchsubject) {
          let chData = "";
          if (this.state.owedqfilterclass != "0") {
            chData = idata.chapters.filter(
              (a) => a.class == this.state.owedqfilterclass,
            );
          } else {
            chData = idata.chapters;
          }
          chData.map((chmapData) => {
            const newObj = {
              value: chmapData.id,
              label: chmapData.chapter,
            };
            getArray.push(newObj);
          });
        }
      }
    }
    this.setState({
      getChaptersArr: getArray,
    });
  };
  getTopics = () => {
    let getArray = [];
    for (let i = 0; i <= this.state.subjects.length; i++) {
      let idata = this.state.subjects[i];
      if (idata != undefined) {
        if (idata.id == this.state.qbsearchsubject) {
          idata.chapters.map((chmapData) => {
            if (chmapData.id == this.state.qbsearchchapter) {
              chmapData.topics.map((topicData) => {
                const newObj = {
                  value: topicData.id,
                  label: topicData.topic,
                };
                getArray.push(newObj);
              });
            }
          });
        }
      }
    }
    //console.log("aravind", getArray)
    this.setState({
      getTopicsArr: getArray,
    });
  };

  questionGenerateType = (e, type, check_type) => {
    this.setState({ generate_type: type, showSpinner: "hide" });
    if (type == "2") {
      if (e.target.checked == true) {
        this.setState({ questionbank_checked: true });
      } else {
        this.setState({ questionbank_checked: false });
      }
    }

    let classArray = this.state.classData.map((item) => {
      if (item.id == 1) {
        return { ...item, active: "outline-secondary active" };
      } else {
        return { ...item, active: "outline-secondary" };
      }
    });
    this.setState({ classData: classArray, syllabusclass: 1 });
  };
  questionPatternType = (type, check_type) => {
    if (this.state.exam_type == 1) {
      if (type == "old") {
        this.setState({ pattern_type: 0 });
      } else {
        this.setState({ pattern_type: 2 });
      }
    } else if (this.state.exam_type == 2) {
      if (type == "old") {
        this.setState({ pattern_type: 0 });
      } else {
        this.setState({ pattern_type: 1 });
      }
    } else {
      this.setState({ pattern_type: 0 });
    }
  };
  complexityType = (type, check_type) => {
    this.setState({ complexity_type_str: type, validateCustomInputValues: "" });
  };

  ownedquestionClassFun1 = (e, data) => {
    //console.log("owedqfilterclass", data);
    let classArray = this.state.classData.map((item) => {
      if (item.id == data) {
        return { ...item, active: "outline-secondary active" };
      } else {
        return { ...item, active: "outline-secondary" };
      }
    });
    this.setState({ classData: classArray, owedqfilterclass: data });
    this.setState({
      class_id: "0",
      classvalue: "",
      qbsearchchapter: "0",
      qbsearchchaptervalue: "",
      qbsearchtopic: [],
      qbsearchtopicvalue: [],
      typeOfQuestion: "0",
      typeOfQuestionvalue: "",
      complexity: "0",
      complexityvalue: "",
      getQuestionBankQuestions: "",
      validateSubject: "",
      validateChapter: "",
      validateTopic: "",
      validateTypeOfQuestion: "",
      validateComplexity: "",
      checkedVall: false,
      activePage: 1,
      totalItemsCount: 0,
      itemsCountPerPage: 10,
      showSpinner: "hide",

      submitError1: "",
      formErrors: {
        exam_type: "",
        branch: "",
        class: "",
        section: "",
        exam_name: "",
        eamcetExamType: "",
        timeduration: "",
      },
      questionbank_checked: false,
      paginationShowBlock: "",
      showQuestionsNotAvailable: "yes",
      scheduledSubType_id: 0,
      scheduledSubTypeValue: "",
    });

    setTimeout(() => {
      this.getChapters();
    }, 500);
  };
  syllabusClassFun = (e, data) => {
    console.log("syllabusClassFun", data, this.state.classData);
    let classArray = this.state.classData.map((item) => {
      if (item.id == data) {
        return { ...item, active: "outline-secondary active" };
      } else {
        return { ...item, active: "outline-secondary" };
      }
    });
    this.setState({
      classData: classArray,
      syllabusclass: data,
      classvalue: data,
    });

    let examsData = this.props.globals.exams.find(
      (a) => a.id == this.state.exam_type,
    );
    let examsubjectData = examsData.exam_subjects;
    let subjects = [];
    let subjectOptionsArr = [];
    // newcodeend
    for (let i = 0; i <= examsubjectData.length; i++) {
      let idata = examsubjectData[i];
      // //console.log("idata", this.state.subjects);
      if (idata != undefined) {
        let subjectData = this.state.subjects.find(
          (a) => a.id == idata.subject_id,
        );
        // //console.log("subjectData", subjectData);
        let chapters = [];
        if (
          this.state.exam_type == "3" ||
          this.state.exam_type == "6" ||
          this.state.exam_type == "7" ||
          this.state.exam_type == "8"
        ) {
          chapters = subjectData.chapters
            .filter(
              (item1) =>
                parseInt(item1.exam_id) == parseInt(this.state.exam_type),
            )
            .map((item) => {
              //console.log("mahdhhhhh", item);
              const topic = item.topics.map((topicData) => {
                return { ...topicData };
              });

              return {
                ...item,
                topics: topic,
                chapteractive:
                  "d-flex justify-content-between align-items-center",
              };
            });
        } else {
          chapters = subjectData.chapters.map((item) => {
            // //console.log("subjectData", subjectData);
            const topic = item.topics.map((topicData) => {
              return { ...topicData };
            });

            return {
              ...item,
              topics: topic,
              chapteractive:
                "d-flex justify-content-between align-items-center",
            };
          });
        }
        const newObject = {
          id: subjectData.id,
          subject: subjectData.subject,
          chapters: chapters,
          checked: subjectData.checked,
          subjectactive: "d-flex justify-content-between align-items-center",
          qcount: subjectData.qcount,
          totError: "",
        };
        const newObj = {
          value: subjectData.id,
          label: subjectData.subject,
        };
        subjects.push(newObject);
        subjectOptionsArr.push(newObj);
      }
    }
    this.setState({
      subjects: subjects,
      subjectOptions: subjectOptionsArr,
    });
  };

  subjectFunction = (subjectid) => {
    console.log(
      "subjectFunction",
      this.state.subjects,
      this.state.subjects.some((item) => item.checked),
    );
    let anyOneSubjectChecked = this.state.subjects.some((item) => item.checked);
    let subjectarray = [];
    if (
      anyOneSubjectChecked &&
      (this.state.exam_type == 9 ||
        this.state.exam_type == 10 ||
        this.state.exam_type == 11)
    ) {
      subjectarray = this.state.subjects.map((submapData) => {
        if (submapData.checked == true) {
          return {
            ...submapData,
            subjectactive:
              "d-flex justify-content-between align-items-center active",
          };
        } else {
          return {
            ...submapData,
            subjectactive:
              "d-flex justify-content-between align-items-center disabled",
          };
        }
      });
    } else {
      subjectarray = this.state.subjects.map((submapData) => {
        if (submapData.id == subjectid) {
          return {
            ...submapData,
            subjectactive:
              "d-flex justify-content-between align-items-center active",
          };
        }
        return {
          ...submapData,
          subjectactive: "d-flex justify-content-between align-items-center",
        };
      });
    }
    this.setState({ subjects: subjectarray });
  };

  chapterFunction = (subjectid, chapterid) => {
    let subjectarray = this.state.subjects.map((submapData) => {
      if (submapData.id == subjectid) {
        const chapData = submapData.chapters.map((chaptermapData) => {
          if (chaptermapData.id == chapterid) {
            return {
              ...chaptermapData,
              chapteractive:
                "d-flex justify-content-between align-items-center active",
            };
          }
          return {
            ...chaptermapData,
            chapteractive: "d-flex justify-content-between align-items-center",
          };
        });
        return { ...submapData, chapters: chapData };
      }
      return { ...submapData };
    });
    this.setState({ subjects: subjectarray });
  };
  topicFunction = (e, subjectid, chapterid, topicid) => {
    console.log(
      "topicFunction",
      e.target.checked,
      subjectid,
      chapterid,
      topicid,
    );
    let subjectarray = this.state.subjects.map((submapData) => {
      if (submapData.id == subjectid) {
        console.log("submapData", submapData);
        if (e.target.checked == true) {
          const chapData = submapData.chapters.map((chaptermapData) => {
            if (chaptermapData.id == chapterid) {
              const topicData = chaptermapData.topics.map((topicmapData) => {
                if (topicmapData.id == topicid) {
                  return { ...topicmapData, checked: true };
                }
                return { ...topicmapData };
              });
              return { ...chaptermapData, checked: true, topics: topicData };
            }
            return { ...chaptermapData };
          });
          return { ...submapData, chapters: chapData, checked: true };
        } else {
          const chapData = submapData.chapters.map((chaptermapData) => {
            if (chaptermapData.id == chapterid) {
              const topicData = chaptermapData.topics.map((topicmapData) => {
                if (topicmapData.id == topicid) {
                  return { ...topicmapData, checked: false };
                }
                return { ...topicmapData };
              });
              let tData = topicData.filter((a) => a.checked == true);
              if (tData.length > 0) {
                return { ...chaptermapData, checked: true, topics: topicData };
              } else {
                return { ...chaptermapData, checked: false, topics: topicData };
              }
            }
            return { ...chaptermapData };
          });
          let cData = chapData.filter((a) => a.checked == true);
          if (cData.length > 0) {
            return { ...submapData, chapters: chapData, checked: true };
          } else {
            return { ...submapData, chapters: chapData, checked: false };
          }
        }
      }

      console.log("submapData1111", submapData);

      return {
        ...submapData,
        subjectactive:
          "d-flex justify-content-between align-items-center disabled",
      };
    });
    this.setState({ subjects: subjectarray });
  };
  topiccheckallFunction = (e, subjectid, chapterid) => {
    let subjectarray = this.state.subjects.map((submapData) => {
      if (submapData.id == subjectid) {
        if (e.target.checked == true) {
          const chapData = submapData.chapters.map((chaptermapData) => {
            if (chaptermapData.id == chapterid) {
              const topicData = chaptermapData.topics.map((topicsmapData) => {
                return { ...topicsmapData, checked: true };
              });
              return {
                ...chaptermapData,
                checked: true,
                topics: topicData,
                checkedall: true,
              };
            }
            return { ...chaptermapData };
          });

          return { ...submapData, checked: true, chapters: chapData };
        } else {
          const chapData = submapData.chapters.map((chaptermapData) => {
            if (chaptermapData.id == chapterid) {
              const topicData = chaptermapData.topics.map((topicsmapData) => {
                return { ...topicsmapData, checked: false };
              });
              return {
                ...chaptermapData,
                checked: false,
                topics: topicData,
                checkedall: false,
              };
            }
            return { ...chaptermapData };
          });
          return { ...submapData, checked: false, chapters: chapData };
        }
      }
      return { ...submapData };
    });
    this.setState({ subjects: subjectarray });
  };

  // squestioncount = (e, subid) => {

  //     let arr = this.state.subjects.map(item => {
  //         //console.log(e.target.value, "subjects");
  //         if (item.id == subid) {
  //             const re = /^[0-9\b]+$/;
  //             if (re.test(e.target.value)) {
  //                 return { ...item, qcount: parseInt(e.target.value), totError: "" };
  //             } else {
  //                 return { ...item, qcount: "", totError: "Invalid Input" }
  //             }
  //             // const qtype = item.questionTheory.map(qitem => {
  //             //     if (qitem.id == qtyid) {
  //             //         const re = /^[0-9\b]+$/;
  //             //         if (re.test(e.target.value)) {
  //             //             if (e.target.value > 100) {
  //             //                 return { ...qitem, percentage: "", totperError: "Total percentage should be 100%" }
  //             //             }
  //             //             else {
  //             //                 return { ...qitem, percentage: e.target.value, totperError: "" }
  //             //             }
  //             //         } else {
  //             //             return { ...qitem, percentage: "", totperError: "Invalid Input" }
  //             //         }

  //             //     }
  //             //     return qitem;
  //             // })

  //         }
  //         return item;
  //     }

  //     )
  //     this.setState({ subjects: arr });
  //     //this.totalpercentagequestionTheory(arr, subid, qtyid);

  // }

  squestioncount = (e, subid) => {
    const value = e.target.value;
    const re = /^[0-9\b]+$/;

    // Pick max limit based on exam_typeValue
    const maxLimit =
      this.state.exam_type == 1 ? 45 : this.state.exam_type == 2 ? 25 : 50;

    const updated = this.state.subjects.map((item) => {
      if (item.id !== subid) return item;

      // Only digits allowed
      if (!re.test(value)) {
        return {
          ...item,
          qcount: "",
          totError: "Invalid Input",
        };
      }

      // Empty input
      if (value === "") {
        return {
          ...item,
          qcount: "",
          totError: "",
        };
      }

      const number = parseInt(value);

      // Check max limit
      if (number > maxLimit) {
        return {
          ...item,
          qcount: "",
          totError: `Max allowed is ${maxLimit}`,
        };
      }

      // Valid input
      return {
        ...item,
        qcount: number,
        totError: "",
      };
    });

    this.setState({ subjects: updated });
  };

  QuestionFunction = (e, questionsdata, type) => {
    //console.log("mQuestionFunction", e, questionsdata, type, this.state.subjects);

    let subjectArray = [];

    if (type == "qbank") {
      if (this.state.generate_type == "2") {
        if (e?.target?.checked == true) {
          //console.log("e.target.checked", e.target.id)
          //validation
          if (this.state.qbsearchsubject == "1") {
            if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
              if (
                this.state.integerQuestionsBotanySelected.length >
                this.state.integerQuestionCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            } else {
              if (
                this.state.generalQuestionsBotanySelected.length >
                this.state.generalQuestionsCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            }
          } else if (this.state.qbsearchsubject == "2") {
            if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
              if (
                this.state.integerQuestionsPhysicsSelected.length >
                this.state.integerQuestionCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            } else {
              if (
                this.state.generalQuestionsPhysicsSelected.length >
                this.state.generalQuestionsCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            }
          } else if (this.state.qbsearchsubject == "3") {
            if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
              if (
                this.state.integerQuestionsChemistrySelected.length >
                this.state.integerQuestionCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            } else {
              if (
                this.state.generalQuestionsChemistrySelected.length >
                this.state.generalQuestionsCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            }
          } else if (this.state.qbsearchsubject == "4") {
            if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
              if (
                this.state.integerQuestionsMathsSelected.length >
                this.state.integerQuestionCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            } else if (this.state.exam_type == 3 || this.state.exam_type == 6) {
              if (this.state.generalQuestionsMathsSelected.length > 79) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            } else {
              if (
                this.state.generalQuestionsMathsSelected.length >
                this.state.generalQuestionsCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            }
          } else if (this.state.qbsearchsubject == "5") {
            if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
              if (
                this.state.integerQuestionsZoologySelected.length >
                this.state.integerQuestionCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            } else {
              if (
                this.state.generalQuestionsZoologySelected.length >
                this.state.generalQuestionsCount
              ) {
                scroller.scrollTo("your_css_class_here", {
                  duration: 800,
                  delay: 0,
                  smooth: "easeInOutQuart",
                });
                this.setState({ checked: !this.state.checkedVall });
                return;
              }
            }
          } else if (this.state.qbsearchsubject == "6") {
            if (
              this.state.generalQuestionsBiologySelected.length >
              this.state.generalQuestionsCount
            ) {
              scroller.scrollTo("your_css_class_here", {
                duration: 800,
                delay: 0,
                smooth: "easeInOutQuart",
              });
              this.setState({ checked: !this.state.checkedVall });
              return;
            }
          }
          //validation
          if (this.state.qbsearchsubject == "1") {
            if (questionsdata.qtype == "8") {
              this.state.integerQuestionsBotanySelected.push(questionsdata);
            } else {
              this.state.generalQuestionsBotanySelected.push(questionsdata);
            }
          } else if (this.state.qbsearchsubject == "2") {
            if (questionsdata.qtype == "8") {
              this.state.integerQuestionsPhysicsSelected.push(questionsdata);
            } else {
              this.state.generalQuestionsPhysicsSelected.push(questionsdata);
            }
          } else if (this.state.qbsearchsubject == "3") {
            if (questionsdata.qtype == "8") {
              this.state.integerQuestionsChemistrySelected.push(questionsdata);
            } else {
              this.state.generalQuestionsChemistrySelected.push(questionsdata);
            }
          } else if (this.state.qbsearchsubject == "5") {
            if (questionsdata.qtype == "8") {
              this.state.integerQuestionsZoologySelected.push(questionsdata);
            } else {
              this.state.generalQuestionsZoologySelected.push(questionsdata);
            }
          } else if (this.state.qbsearchsubject == "4") {
            if (questionsdata.qtype == "8") {
              this.state.integerQuestionsMathsSelected.push(questionsdata);
            } else {
              this.state.generalQuestionsMathsSelected.push(questionsdata);
            }
          } else if (this.state.qbsearchsubject == "6") {
            this.state.generalQuestionsBiologySelected.push(questionsdata);
          }
        } else {
          //console.log("checjed");

          if (this.state.qbsearchsubject == "1") {
            if (questionsdata.qtype == "8") {
              for (var i in this.state.integerQuestionsBotanySelected) {
                if (
                  this.state.integerQuestionsBotanySelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.integerQuestionsBotanySelected.splice(i, 1);
                  this.setState({
                    integerQuestionsBotanySelected:
                      this.state.integerQuestionsBotanySelected,
                  });
                }
              }
            } else {
              for (var i in this.state.generalQuestionsBotanySelected) {
                if (
                  this.state.generalQuestionsBotanySelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.generalQuestionsBotanySelected.splice(i, 1);
                  this.setState({
                    generalQuestionsBotanySelected:
                      this.state.generalQuestionsBotanySelected,
                  });
                }
              }
            }
          } else if (this.state.qbsearchsubject == "2") {
            if (questionsdata.qtype == "8") {
              for (var i in this.state.integerQuestionsPhysicsSelected) {
                if (
                  this.state.integerQuestionsPhysicsSelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.integerQuestionsPhysicsSelected.splice(i, 1);
                  this.setState({
                    integerQuestionsPhysicsSelected:
                      this.state.integerQuestionsPhysicsSelected,
                  });
                }
              }
            } else {
              for (var i in this.state.generalQuestionsPhysicsSelected) {
                if (
                  this.state.generalQuestionsPhysicsSelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.generalQuestionsPhysicsSelected.splice(i, 1);
                  this.setState({
                    generalQuestionsPhysicsSelected:
                      this.state.generalQuestionsPhysicsSelected,
                  });
                }
              }
            }
          } else if (this.state.qbsearchsubject == "3") {
            if (questionsdata.qtype == "8") {
              for (var i in this.state.integerQuestionsChemistrySelected) {
                if (
                  this.state.integerQuestionsChemistrySelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.integerQuestionsChemistrySelected.splice(i, 1);
                  this.setState({
                    integerQuestionsChemistrySelected:
                      this.state.integerQuestionsChemistrySelected,
                  });
                }
              }
            } else {
              for (var i in this.state.generalQuestionsChemistrySelected) {
                if (
                  this.state.generalQuestionsChemistrySelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.generalQuestionsChemistrySelected.splice(i, 1);
                  this.setState({
                    generalQuestionsChemistrySelected:
                      this.state.generalQuestionsChemistrySelected,
                  });
                }
              }
            }
          } else if (this.state.qbsearchsubject == "5") {
            if (questionsdata.qtype == "8") {
              for (var i in this.state.integerQuestionsZoologySelected) {
                if (
                  this.state.integerQuestionsZoologySelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.integerQuestionsZoologySelected.splice(i, 1);
                  this.setState({
                    integerQuestionsZoologySelected:
                      this.state.integerQuestionsZoologySelected,
                  });
                }
              }
            } else {
              for (var i in this.state.generalQuestionsZoologySelected) {
                if (
                  this.state.generalQuestionsZoologySelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.generalQuestionsZoologySelected.splice(i, 1);
                  this.setState({
                    generalQuestionsZoologySelected:
                      this.state.generalQuestionsZoologySelected,
                  });
                }
              }
            }
          } else if (this.state.qbsearchsubject == "4") {
            if (questionsdata.qtype == "8") {
              for (var i in this.state.integerQuestionsMathsSelected) {
                if (
                  this.state.integerQuestionsMathsSelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.integerQuestionsMathsSelected.splice(i, 1);
                  this.setState({
                    integerQuestionsMathsSelected:
                      this.state.integerQuestionsMathsSelected,
                  });
                }
              }
            } else {
              for (var i in this.state.generalQuestionsMathsSelected) {
                if (
                  this.state.generalQuestionsMathsSelected[i].id ==
                  questionsdata.id
                ) {
                  this.state.generalQuestionsMathsSelected.splice(i, 1);
                  this.setState({
                    generalQuestionsMathsSelected:
                      this.state.generalQuestionsMathsSelected,
                  });
                }
              }
            }
          } else if (this.state.qbsearchsubject == "6") {
            for (var i in this.state.generalQuestionsBiologySelected) {
              if (
                this.state.generalQuestionsBiologySelected[i].id ==
                questionsdata.id
              ) {
                this.state.generalQuestionsBiologySelected.splice(i, 1);
                this.setState({
                  generalQuestionsBiologySelected:
                    this.state.generalQuestionsBiologySelected,
                });
              }
            }
          }
        }
      }

      //console.log("wwwwwwwwwwwwwwwwwww", this.state.generalQuestionsBotanySelected.length);

      subjectArray = this.state.subjects.map((subjectData) => {
        if (subjectData.id == this.state.qbsearchsubject) {
          const chData = subjectData.chapters.map((chmapData) => {
            if (chmapData.id == this.state.qbsearchchapter) {
              if (e.target.checked == true) {
                let array = chmapData.questionbarray;
                array.push({ ...questionsdata });
                return { ...chmapData, questionbarray: array };
              } else {
                const questionbarray = chmapData.questionbarray.filter(
                  (a) => a.id != questionsdata.id,
                );
                //questionbarray.push(questionsdata);
                return { ...chmapData, questionbarray: questionbarray };
              }
            }
            return { ...chmapData };
          });
          return { ...subjectData, chapters: chData };
        }
        return { ...subjectData };
      });
    }

    this.setState({ subjects: subjectArray });
  };

  selecthandleInputChange = async (ename, evalue) => {
    //console.log("selecthandleInputChange", ename, evalue);
    const name = ename;
    const value = evalue;

    if (name == "qbsearchsubject") {
      let subjectData = this.state.subjects.find((a) => a.id == value);
      this.setState({
        qbsearchsubjectvalue: {
          value: subjectData.id,
          label: subjectData.subject,
        },
        //qbQuestionSearchSubject:subjectData.id,
        qbsearchchapter: "",
        qbsearchchaptervalue: "",
        qbsearchtopic: [],
        qbsearchtopicvalue: [],
        typeOfQuestion: "",
        typeOfQuestionvalue: "",
        complexity: "",
        complexityvalue: "",
        paginationShowBlock: "",
        validateSubject: "",
      });

      let questionTypesData = this.props.globals.questionTypes.find(
        (a) => a.id == 7,
      );
      //console.log("typeOfQuestion", questionTypesData)
      this.setState({
        typeOfQuestionvalue: {
          value: questionTypesData.id,
          label: questionTypesData.questiontype,
        },
        typeOfQuestion: questionTypesData.id,
      });

      setTimeout(() => {
        this.getChapters();
      }, 800);
    }
    if (name == "qbsearchchapter") {
      let subjectData = this.state.subjects.find(
        (a) => a.id == this.state.qbsearchsubject,
      );
      let chData = subjectData.chapters.find((a) => a.id == value);

      this.setState({
        qbsearchchaptervalue: {
          value: chData.id,
          label: chData.chapter,
        },
        qbsearchtopic: [],
        qbsearchtopicvalue: [],
        validateChapter: "",
      });

      setTimeout(() => {
        this.getTopics();
      }, 1000);
    }
    if (name == "typeOfQuestion") {
      let questionTypesData = this.props.globals.questionTypes.find(
        (a) => a.id == value,
      );
      //console.log("typeOfQuestion", questionTypesData)
      if (this.state.exam_type == 1) {
        if (questionTypesData.id == 7) {
          this.setState({
            typeOfQuestionvalue: {
              value: questionTypesData.id,
              label: questionTypesData.questiontype,
            },
          });
        }
      } else {
        this.setState({
          typeOfQuestionvalue: {
            value: questionTypesData.id,
            label: questionTypesData.questiontype,
          },
        });
      }
    }
    if (name == "complexity") {
      let complexityData = this.props.globals.complexity.find(
        (a) => a.id == value,
      );
      this.setState({
        complexityvalue: {
          value: complexityData.id,
          label: complexityData.complexity,
        },
      });
    }
    if (name == "scheduledSubType_id") {
      console.log(
        "this.state.getScheduledTypesArr",
        this.state.getScheduledTypesArr,
      );
      let data = this.state.getScheduledTypesArr.find((a) => a.value == value);
      this.setState({
        scheduledSubTypeValue: {
          value: data.value,
          label: data.label,
        },
      });
    }
    if (name == "class_id") {
      let classData = this.props.globals.classes.find((a) => a.id == value);
      this.setState({
        classvalue: {
          value: classData.id,
          label: classData.class,
        },
        submitError1: "",
      });
    }

    if (name == "exam_generate_class_value") {
      let classData = this.props.globals.classes.find((a) => a.id == value);
      this.setState({
        exam_generate_class: {
          value: classData.id,
          label: classData.class,
        },
      });
    }
    if (name == "exam_generate_type") {
      let generateTypes = this.state.getGenerateTypes.find(
        (a) => a.value == value,
      );

      let examsData = this.props.globals.exams.find(
        (a) => a.id == this.state.exam_type,
      );
      let examsubjectData = examsData.exam_subjects;
      let subjects = [];

      // newcodeend

      for (let i = 0; i <= examsubjectData.length; i++) {
        let idata = examsubjectData[i];
        //console.log("idata", idata);
        if (idata != undefined) {
          let subjectData = this.props.globals.subjects.find(
            (a) => a.id == idata.subject_id,
          );
          // //console.log("subjectData", subjectData);
          let chapters = [];
          if (this.state.exam_type == "1" || this.state.exam_type == "2") {
            chapters = subjectData.chapters.map((item) => {
              //console.log("subjectData", subjectData);
              const topic = item.topics.map((topicData) => {
                return { ...topicData, checked: false };
              });

              return {
                ...item,
                topics: topic,
                chapteractive:
                  "d-flex justify-content-between align-items-center",
                checked: false,
                checkedall: false,
                ownedarray: [],
                questionbarray: [],
              };
            });
          } else {
            chapters = subjectData.state_chapters
              .filter(
                (item1) =>
                  parseInt(item1.exam_id) == parseInt(this.state.exam_type),
              )
              .map((item) => {
                //console.log("subjectDatassss", chapters);
                const topic = item.state_topics.map((topicData) => {
                  return { ...topicData, checked: false };
                });

                return {
                  ...item,
                  topics: topic,
                  chapteractive:
                    "d-flex justify-content-between align-items-center",
                  checked: false,
                  checkedall: false,
                  ownedarray: [],
                  questionbarray: [],
                };
              });
          }
          let questions_count =
            this.state.exam_type == "1" || this.state.exam_type == "2"
              ? idata.no_of_questions
              : generateTypes.value == "group_custom"
                ? 0
                : idata.no_of_questions;
          const newObject = {
            id: subjectData.id,
            subject: subjectData.subject,
            chapters: chapters,
            checked: false,
            subjectactive: "d-flex justify-content-between align-items-center",
            qcount: questions_count,
            totError: "",
          };

          subjects.push(newObject);
        }
      }

      let pattern_type = this.state.pattern_type;

      if (
        generateTypes.value == "group_custom" &&
        this.state.exam_type != "1" &&
        this.state.exam_type != "2"
      ) {
        pattern_type = 3;
      } else if (
        generateTypes.value != "group_custom" &&
        this.state.exam_type != "1" &&
        this.state.exam_type != "2"
      ) {
        pattern_type = 0;
      }

      this.setState({
        exam_generate_type_value: {
          value: generateTypes.value,
          label: generateTypes.label,
        },
        subjects,
        pattern_type,
      });
    }
    if (name == "exam_type") {
      let easy_easyVal = 0;
      let easy_modarateVal = 0;
      let easy_difficultVal = 0;
      let standard_easyVal = 0;
      let standard_modarateVal = 0;
      let standard_difficultVal = 0;
      let examTypeValues = this.props.globals.exams.find((a) => a.id == value);

      let subjectsData = [];

      // //console.log("mahesh", this.state.subjects);

      // if(examTypeValues.id == "3" || examTypeValues.id == "6" || examTypeValues.id == "7" || examTypeValues.id == "8"){

      // }else{
      //     this.state.subjects.map((item) => {
      //             subjectsData.push({ ...item })
      //     })
      // }

      //console.log("subjectsData", subjectsData);

      let patternType = 0;

      if (examTypeValues.id != 1 && examTypeValues.id != 2) {
        patternType = 3;
      }

      this.setState({
        exam_typeValue: {
          value: examTypeValues.id,
          label: examTypeValues.exam,
        },
        pattern_type: patternType,
        subjects: subjectsData,
      });

      let clsdata = this.props.globals.classes.map((item) => {
        if (item.id == "1") {
          return { ...item, active: "outline-secondary active" };
        }
        return { ...item, active: "outline-secondary" };
      });

      if (this.props?.getExamStandardPercentage) {
        this.props.getExamStandardPercentage.forEach((item) => {
          if (item?.type_of_exam == "Easy") {
            if (value == item.exam_id) {
              easy_easyVal = item.easy;
              easy_modarateVal = item.moderate;
              easy_difficultVal = item.difficult;
            }
          } else {
            if (value == item?.exam_id) {
              standard_easyVal = item.easy;
              standard_modarateVal = item.moderate;
              standard_difficultVal = item.difficult;
            }
          }
        });
      }

      this.setState({
        easy_easy: easy_easyVal,
        easy_Modarate: easy_modarateVal,
        easy_block_Difficult: easy_difficultVal,
        standard_easy: standard_easyVal,
        standard_block_Modarate: standard_modarateVal,
        standard_block_Difficult: standard_difficultVal,
      });

      this.setState({
        exam_name: "",
        class_id: "0",
        classvalue: "",
        subjects: [],
        classData: clsdata,
        syllabusclass: "1",
        qbQuestionSearchSubject: "",
        qbsearchsubject: "0",
        qbsearchsubjectvalue: "",
        qbsearchchapter: "0",
        qbsearchchaptervalue: "",
        qbsearchtopic: [],
        qbsearchtopicvalue: [],
        typeOfQuestion: "0",
        typeOfQuestionvalue: "",
        complexity: "0",
        complexityvalue: "",
        subjectOptions: [],
        getChaptersArr: [],
        getTopicsArr: [],
        getTypeOfQuestionsArr: [],
        getComplexityValueArr: [],
        getQuestionBankQuestions: "",
        validateSubject: "",
        validateChapter: "",
        validateTopic: "",
        validateTypeOfQuestion: "",
        validateComplexity: "",
        checkedVall: false,
        activePage: 1,
        totalItemsCount: 0,
        itemsCountPerPage: 10,
        showSpinner: "hide",
        otherexam: "",
        noofsets: "1",
        startdate: "",
        enddate: "",
        currentStep: 1,
        getSectionsArr: [],
        branchSelected: [],
        sectionSelected: [],
        sectionSelectedvalue: [],
        generalQuestionsBotanySelected: [],
        generalQuestionsZoologySelected: [],
        generalQuestionsPhysicsSelected: [],
        generalQuestionsChemistrySelected: [],
        generalQuestionsMathsSelected: [],
        integerQuestionsBotanySelected: [],
        integerQuestionsZoologySelected: [],
        integerQuestionsPhysicsSelected: [],
        integerQuestionsChemistrySelected: [],
        integerQuestionsMathsSelected: [],

        generalQuestionsCount: 0,
        integerQuestionCount: 0,
        modalShow: false,
        submitError1: "",
        paper_generate_type: "",
        timeduration: 90,
        formErrors: {
          exam_type: "",
          branch: "",
          class: "",
          section: "",
          exam_name: "",
          timeduration: "",
        },
        questionbank_checked: false,
        exam_generate_type: "group_custom",
        exam_generate_type_value: { value: "group_custom", label: "Custom" },
        showQuestionsNotAvailable: "yes",
        scheduledSubType_id: 0,
        scheduledSubTypeValue: "",
      });

      let examsData = this.props.globals.exams.find((a) => a.id == value);
      let examsubjectData = examsData.exam_subjects;
      let subjects = [];
      let subjectOptionsArr = [];
      // newcodeend
      for (let i = 0; i <= examsubjectData.length; i++) {
        let idata = examsubjectData[i];
        console.log("idata", idata);
        if (idata != undefined) {
          let subjectData = this.props.globals.subjects.find(
            (a) => a.id == idata.subject_id,
          );
          let chapters = [];

          if (value == "1" || value == "2") {
            chapters = subjectData.chapters.map((item) => {
              //console.log("subjectData", subjectData);
              const topic = item.topics.map((topicData) => {
                return { ...topicData, checked: false };
              });

              return {
                ...item,
                topics: topic,
                chapteractive:
                  "d-flex justify-content-between align-items-center",
                checked: false,
                checkedall: false,
                ownedarray: [],
                questionbarray: [],
              };
            });
          } else {
            //console.table(subjectData.state_chapters);
            chapters = subjectData.state_chapters
              .filter((item1) => parseInt(item1.exam_id) == parseInt(value))
              .map((item) => {
                //console.log("subjectDatassss", item);
                const topic = item.state_topics.map((topicData) => {
                  return { ...topicData, checked: false };
                });

                return {
                  ...item,
                  topics: topic,
                  chapteractive:
                    "d-flex justify-content-between align-items-center",
                  checked: false,
                  checkedall: false,
                  ownedarray: [],
                  questionbarray: [],
                };
              });
          }

          let questions_count =
            (evalue == "3" ||
              evalue == "6" ||
              evalue == "7" ||
              evalue == "8" ||
              evalue == "9" ||
              evalue == "10" ||
              evalue == "11") &&
              this.state.exam_generate_type == "group_custom"
              ? 0
              : idata.no_of_questions;
          const newObject = {
            id: subjectData.id,
            subject: subjectData.subject,
            chapters: chapters,
            checked: false,
            subjectactive: "d-flex justify-content-between align-items-center",
            qcount: questions_count,
            totError: "",
          };

          //console.log("hello", newObject);
          const newObj = {
            value: subjectData.id,
            label: subjectData.subject,
          };
          subjects.push(newObject);
          subjectOptionsArr.push(newObj);
        }
      }

      //console.log("fffffffffffffffff", subjects)

      let questionTypeArr = [];
      this.props.globals.questionTypes.map((item) => {
        if (value != "2") {
          if (item.id == 7) {
            const newObj1 = {
              value: item.id,
              label: item.questiontype,
            };
            questionTypeArr.push(newObj1);
          }
        } else {
          if (item.id == 7 || item.id == 8) {
            const newObj1 = {
              value: item.id,
              label: item.questiontype,
            };
            questionTypeArr.push(newObj1);
          }
        }
      });
      let complexityArr = [];
      this.props.globals.complexity.map((item) => {
        if (item.id != 5) {
          const newObj2 = {
            value: item.id,
            label: item.complexity,
          };
          complexityArr.push(newObj2);
        }
      });

      let sectionsArr = [];

      for (let i = 0; i <= this.props.globals.globalSections.length; i++) {
        let idata = this.props.globals.globalSections[i];
        if (idata != undefined) {
          if (value == idata.exam_id) {
            const newObj = {
              value: idata.id,
              label: idata.section_name,
              branch: idata.branch_id,
            };
            sectionsArr.push(newObj);
          }
        }
      }

      this.setState({
        subjects: subjects,
        getSectionsArr: sectionsArr,
        subjectOptions: subjectOptionsArr,
        getTypeOfQuestionsArr: questionTypeArr,
        getComplexityValueArr: complexityArr,
      });
    }

    this.setState({ [name]: value });
  };
  handleInputChange = (e) => {
    //console.log("handleInputChange", e.target.name, e.target.value)

    const name = e.target.name;
    const value = e.target.value;

    let classArray = this.state.classData.map((item) => {
      if (item.id == 1) {
        return { ...item, active: "outline-secondary active" };
      } else {
        return { ...item, active: "outline-secondary" };
      }
    });

    let examsData = this.props.globals.exams.find(
      (a) => a.id == this.state.exam_type,
    );
    let examsubjectData = examsData.exam_subjects;
    let subjects = [];

    if (name == "pattern_type") {
      // newcodeend
      for (let i = 0; i <= examsubjectData.length; i++) {
        let idata = examsubjectData[i];
        //console.log("idata", idata);
        if (idata != undefined) {
          let subjectData = this.props.globals.subjects.find(
            (a) => a.id == idata.subject_id,
          );
          // //console.log("subjectData", subjectData);
          let chapters = [];

          if (
            this.state.exam_type == "3" ||
            this.state.exam_type == "6" ||
            this.state.exam_type == "7" ||
            this.state.exam_type == "8"
          ) {
            chapters = subjectData.state_chapters
              .filter(
                (item1) =>
                  parseInt(item1.exam_id) == parseInt(this.state.exam_type),
              )
              .map((item) => {
                //console.log("subjectDatassss", chapters);
                const topic = item.state_topics.map((topicData) => {
                  return { ...topicData, checked: false };
                });

                return {
                  ...item,
                  topics: topic,
                  chapteractive:
                    "d-flex justify-content-between align-items-center",
                  checked: false,
                  checkedall: false,
                  ownedarray: [],
                  questionbarray: [],
                };
              });
          } else {
            chapters = subjectData.chapters.map((item) => {
              //console.log("subjectData", subjectData);
              const topic = item.topics.map((topicData) => {
                return { ...topicData, checked: false };
              });

              return {
                ...item,
                topics: topic,
                chapteractive:
                  "d-flex justify-content-between align-items-center",
                checked: false,
                checkedall: false,
                ownedarray: [],
                questionbarray: [],
              };
            });
          }

          if (this.state.exam_type == "1" || this.state.exam_type == "2") {
            chapters = subjectData.chapters.map((item) => {
              //console.log("subjectData", subjectData);
              const topic = item.topics.map((topicData) => {
                return { ...topicData, checked: false };
              });

              return {
                ...item,
                topics: topic,
                chapteractive:
                  "d-flex justify-content-between align-items-center",
                checked: false,
                checkedall: false,
                ownedarray: [],
                questionbarray: [],
              };
            });
          } else {
            chapters = subjectData.state_chapters
              .filter(
                (item1) =>
                  parseInt(item1.exam_id) == parseInt(this.state.exam_type),
              )
              .map((item) => {
                //console.log("subjectDatassss", chapters);
                const topic = item.state_topics.map((topicData) => {
                  return { ...topicData, checked: false };
                });

                return {
                  ...item,
                  topics: topic,
                  chapteractive:
                    "d-flex justify-content-between align-items-center",
                  checked: false,
                  checkedall: false,
                  ownedarray: [],
                  questionbarray: [],
                };
              });
          }

          const newObject = {
            id: subjectData.id,
            subject: subjectData.subject,
            chapters: chapters,
            checked: false,
            subjectactive: "d-flex justify-content-between align-items-center",
            qcount: value == 3 ? 0 : idata.no_of_questions,
            totError: "",
          };
          subjects.push(newObject);
        }
      }
    } else {
      subjects.push(...this.state.subjects);
    }

    // exam_generate_type: "group_custom", exam_generate_type_value: { label: "Custom", value: "group_custom" },
    this.setState({
      [name]: value,
      subjects,
      submitError1: "",
      classData: classArray,
      syllabusclass: 1,
    });
  };

  handleMultipleSelectInputChange = (e, name) => {
    //console.log("handleMultipleSelectInputChange", e, name);
    if (name == "topic") {
      let qbsearchtopic = Array();
      let qbsearchtopicvalue = Array();
      if (e != null) {
        for (let i = 0; i < e.length; i++) {
          const qbtopicval = e[i];
          const newObj = {
            label: qbtopicval.label,
            value: qbtopicval.value,
          };
          qbsearchtopicvalue.push(newObj);
          qbsearchtopic.push(qbtopicval.value);
        }
        this.setState({
          qbsearchtopicvalue: qbsearchtopicvalue,
          qbsearchtopic: qbsearchtopic,
          validateTopic: "",
        });
      }
    }
    if (name == "sections") {
      let branchSelected = Array();
      let sectionSelected = Array();
      let sectionSelectedvalue = Array();

      if (e != null) {
        for (let i = 0; i < e.length; i++) {
          const sectionval = e[i];
          //console.log("ddddddd", sectionval)
          const newObj = {
            label: sectionval.label,
            value: sectionval.value,
            branch: sectionval.branch,
          };
          sectionSelectedvalue.push(newObj);
          sectionSelected.push(sectionval.value);
          branchSelected.push(sectionval.branch);
        }
        this.setState({
          sectionSelectedvalue: sectionSelectedvalue,
          sectionSelected: sectionSelected,
          branchSelected: branchSelected,
          submitError1: "",
        });
      }
    }
  };

  handlePageClick = (count) => {
    let currentPage = count.selected + 1;
    this.onScrollgetQuestionById(currentPage);
  };

  onScrollgetQuestionById = async (startedCount) => {
    this.setState({
      validateSubject: "",
      validateChapter: "",
      validateTopic: "",
      validateTypeOfQuestion: "",
      validateComplexity: "",
      getQuestionBankQuestions: "",
      showSpinner: "hide",
      validationMessage: "",
      paginationShowBlock: "",
      showQuestionsNotAvailable: "yes",
    });

    if (this.state.qbsearchsubjectvalue == "") {
      this.setState({ validateSubject: "Please Select Subject" });
      return null;
    } else if (this.state.qbsearchchaptervalue == "") {
      this.setState({ validateChapter: "Please Select Chapter" });
      return;
    } else if (this.state.qbsearchtopicvalue == "") {
      this.setState({ validateTopic: "Please Select Topic" });
      return;
    }
    //  else if (this.state.typeOfQuestionvalue == "") {
    //     this.setState({ validateTypeOfQuestion: "Please Select Type of Question" });
    //     return;
    // }
    /*else if(this.state.complexityvalue == ""){
            this.setState({validateComplexity:"Please Select Complexity" });
            return;
        }*/

    this.setState({ showSpinner: "show" });

    //console.log("handleMultipleSelectInputChange222", this.state.qbsearchtopic)
    //console.log("handleMultipleSelectInputChange111", this.state.qbsearchtopic.toString())

    const result = await this.props.client.query({
      query: gql`
        query (
          $subject: String!
          $chapter: String!
          $topic: String!
          $question_type: String
          $question_theory: String
          $complexity: String
          $institute_id: Int!
          $page: Int
          $type: Int
          $exam_type: Int
        ) {
          getQuestionBankQuestions(
            subject: $subject
            chapter: $chapter
            topic: $topic
            question_type: $question_type
            question_theory: $question_theory
            complexity: $complexity
            institute_id: $institute_id
            page: $page
            type: $type
            exam_type: $exam_type
          ) {
            id
            subject
            question
            chapter
            topic
            complexity
            question_theory
            qtype
            mat_question
            compquestion
            list1type
            list2type
            subject_name
            chapter_name
            topic_name
            option1
            option2
            option3
            option4
            answer
            usageset
          }
        }
      `,
      variables: {
        subject: this.state.qbsearchsubject,
        chapter: this.state.qbsearchchapter,
        topic: this.state.qbsearchtopic.toString(),
        question_type: this.state.typeOfQuestion,
        question_theory: "0",
        complexity: this.state.complexity,
        institute_id: parseInt(Cookies.get("institutionid")),
        page: 1,
        type: 1,
        exam_type: parseInt(this.state.exam_type),
      },
      fetchPolicy: "network-only",
    });

    //console.log("aaaaa", result);

    if (result.data.getQuestionBankQuestions.length > 0) {
      this.setState({
        showSpinner: "hide",
        getQuestionBankQuestions: result.data.getQuestionBankQuestions,
        paginationShowBlock: "0",
      });
    } else {
      this.setState({
        showQuestionsNotAvailable: "no",
        getQuestionBankQuestions: "",
        showSpinner: "hide",
      });
    }
  };
  idFunction(data) {
    let id = parseInt(data + 1);
    return id;
  }
  handlePageChange(pageNumber) {
    //console.log(`active page is ${pageNumber}`);
    this.setState({ activePage: pageNumber });
  }
  quentionSearchhandleChange = (e) => {
    this.setState({
      qbQuestionSearchSubject: e.target.value,
    });
  };

  removeHTML = (question) => {
    var tmp = document.createElement("p");
    tmp.innerHTML = question;
    return tmp.textContent || tmp.innerText || "";
  };
  actionFormatterLearn(cell, row, rowIndex) {
    if (row.Questions.qtype == "9" || row.Questions.qtype == "3") {
      //console.log("questionsData.question", row.Questions.question, row.Questions.id);
      let question1 = row.Questions.question.replace(/src="/g, 'src=\\"');
      let question2 = question1.replace(/" \/>/g, '\\" />');
      let question = [];
      try {
        question = JSON.parse(question2);
      } catch (err) {
        //console.log("MATRIX ERROR:", err.message);
      }

      return (
        <Card as={Card.Body} className="bg-light my-2">
          <Form.Check type="checkbox" id={"checkbox_1001" + rowIndex} custom>
            {row.Questions.checked == true ? (
              <Form.Check.Input
                type="checkbox"
                checked={row.Questions.checked}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            ) : (
              <Form.Check.Input
                type="checkbox"
                checked={this.state.checkedVall}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            )}
            <Form.Check.Label htmlFor={"checkbox_1001" + rowIndex}>
              {parse(row.Questions.mat_question)}
              <p className="font-weight-bold">{" QID- " + row.Questions.id}</p>
              <Row>
                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                  <ol
                    className="matrixlistoptions"
                    type={
                      row.Questions.list1type == "alphabets"
                        ? "A"
                        : row.Questions.list1type == "numbers"
                          ? "1"
                          : "roman"
                    }
                  >
                    {question.map((item) => (
                      <li>{parse(item.qlist1)}</li>
                    ))}
                  </ol>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                  <ol
                    className="matrixlistoptions"
                    type={
                      row.Questions.list2type == "alphabets"
                        ? "A"
                        : row.Questions.list2type == "numbers"
                          ? "1"
                          : "roman"
                    }
                  >
                    {question.map((item) => (
                      <li>{parse(item.qlist2)}</li>
                    ))}
                  </ol>
                </Col>
              </Row>
            </Form.Check.Label>
          </Form.Check>
          <hr className="my-3" />
          <Row>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">A.</span>
                <div className="ml-2">{parse(row.Questions.option1)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">B.</span>
                <div className="ml-2">{parse(row.Questions.option2)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">C.</span>
                <div className="ml-2">{parse(row.Questions.option3)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">D.</span>
                <div className="ml-2">{parse(row.Questions.option4)}</div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} className="my-2">
              <div className="d-flex align-items-center color_000">
                <span className="font-weight-bold">Currect Answer:</span>
                <div className="font-weight-bold ml-2">
                  {row.Questions.answer}
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      );
    } else if (row.Questions.qtype == "8") {
      // //console.log("questionsData.questionnn", question);
      return (
        <Card as={Card.Body} className="bg-light my-2">
          <Form.Check type="checkbox" id={"checkbox_2011" + rowIndex} custom>
            {row.Questions.checked == true ? (
              <Form.Check.Input
                type="checkbox"
                checked={row.Questions.checked}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            ) : (
              <Form.Check.Input
                type="checkbox"
                checked={this.state.checkedVall}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            )}
            <Form.Check.Label htmlFor={"checkbox_2011" + rowIndex}>
              {parse(row.Questions.question)}
              <p className="font-weight-bold">{" QID- " + row.Questions.id}</p>
            </Form.Check.Label>
          </Form.Check>
          <hr className="my-3" />
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} className="my-2">
              <div className="d-flex align-items-center color_000">
                <span className="font-weight-bold">Currect Answer:</span>
                <div className="font-weight-bold ml-2">
                  {row.Questions.answer}
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      );
    } else if (row.Questions.qtype == "5") {
      ////console.log("questionsData.questionnn", question);
      return (
        <Card as={Card.Body} className="bg-light my-2">
          <Form.Check type="checkbox" id={"checkbox_3021" + rowIndex} custom>
            {row.Questions.checked == true ? (
              <Form.Check.Input
                type="checkbox"
                checked={row.Questions.checked}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            ) : (
              <Form.Check.Input
                type="checkbox"
                checked={this.state.checkedVall}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            )}
            <Form.Check.Label htmlFor={"checkbox_3021" + rowIndex}>
              {parse(row.Questions.compquestion)}
              {parse(row.Questions.question)}
              <p className="font-weight-bold">{" QID- " + row.Questions.id}</p>
            </Form.Check.Label>
          </Form.Check>
          <hr className="my-3" />
          <Row>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">A.</span>
                <div className="ml-2">{parse(row.Questions.option1)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">B.</span>
                <div className="ml-2">{parse(row.Questions.option2)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">C.</span>
                <div className="ml-2">{parse(row.Questions.option3)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">D.</span>
                <div className="ml-2">{parse(row.Questions.option4)}</div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} className="my-2 ">
              <div className="d-flex align-items-center color_000">
                <span className="font-weight-bold">Currect Answer:</span>
                <div className="font-weight-bold ml-2">
                  {row.Questions.answer}
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      );
    } else {
      // //console.log("questionsData.questionnn", question);
      return (
        <Card as={Card.Body} className="bg-light my-2">
          <Form.Check type="checkbox" id={"checkbox_4031" + rowIndex} custom>
            {row.Questions.checked == true ? (
              <Form.Check.Input
                type="checkbox"
                checked={row.Questions.checked}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            ) : (
              <Form.Check.Input
                type="checkbox"
                checked={this.state.checkedVall}
                onChange={(e) => {
                  this.QuestionFunction(e, row.Questions, "qbank");
                }}
              />
            )}
            <Form.Check.Label htmlFor={"checkbox_4031" + rowIndex}>
              {parse(row.Questions.question)}
              <p className="font-weight-bold">{" QID- " + row.Questions.id}</p>
            </Form.Check.Label>
          </Form.Check>
          <hr className="my-3" />
          <Row>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">A.</span>
                <div className="ml-2">{parse(row.Questions.option1)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">B.</span>
                <div className="ml-2">{parse(row.Questions.option2)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">C.</span>
                <div className="ml-2">{parse(row.Questions.option3)}</div>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} sm={12} className="my-2">
              <div className="d-flex align-items-center">
                <span className="f-16">D.</span>
                <div className="ml-2">{parse(row.Questions.option4)}</div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} className="my-2">
              <div className="d-flex align-items-center color_000">
                <span className="font-weight-bold">Currect Answer:</span>
                <div className="font-weight-bold ml-2">
                  {row.Questions.answer}
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      );
    }
  }

  questionsTable = (data) => {
    let dataArr = [];
    data.map((questionsData, index) => {
      const obj = {
        Questions: questionsData,
      };
      dataArr.push(obj);
    });
    return dataArr;
  };

  colFunction = [
    {
      dataField: "Questions",
      text: "Questions",
      formatter: this.actionFormatterLearn.bind(this),
    },
  ];
  datefunction = (moment1, name) => {
    //console.log("datefunction", moment1._d, name);
    let date = String(moment1);
    var res = date.substr(4, 20);
    let add3Hours = moment(moment1).add(3, "hours").format("DD-MM-YYYY LT");
    let autoEndDate = moment(moment1)
      .add(3, "hours")
      .format("MMM DD YYYY HH:mm:ss");
    //console.log("addHours", add3Hours)
    this.setState({
      startdate: res,
      add3Hours_val: add3Hours,
      enddate: autoEndDate,
    });

    this.setState({
      submitError1: "",
    });

    //console.log("addHours", this.state.add3Hours_val)
  };
  datefunctionend = (moment1, name) => {
    //console.log("datefunction", moment1._d, name);
    let date = String(moment1);
    var res = date.substr(4, 20);
    let add3Hours = moment(res).format("DD-MM-YYYY LT");
    this.setState({ enddate: res, add3Hours_val: add3Hours });

    this.setState({
      submitError1: "",
    });
  };

  getClassData() {
    let getArray = [];
    for (let i = 0; i <= this.props.globals.classes.length; i++) {
      let idata = this.props.globals.classes[i];
      if (idata != undefined) {
        const newObj = {
          value: idata.id,
          label: idata.class,
        };
        getArray.push(newObj);
      }
    }
    return getArray;
  }

  showQuestionGenerateModal = (e, paper_generate_type) => {
    // Both "Generate" and "Save Draft" (QuestionSelectedDetails) open the create
    // modal through here, so this one gate covers every path into the form.
    if (!this.requireEdit()) return;

    //validateExamType
    if (paper_generate_type == "save") {
      if (this.state.complexity_type_str == "custom") {
        if (
          this.state.custom_easy_val == "" ||
          this.state.custom_modarate_val == "" ||
          this.state.custom_difficult_val == ""
        ) {
          this.setState({ validateCustomInputValues: "Please Enter Values" });
          return;
        }
      }
      this.setState({
        modalShow: true,
        submitError1: "",
        paper_generate_type: paper_generate_type,
      });
    } else {
      this.setState({
        modalShow: true,
        submitError1: "",
        paper_generate_type: paper_generate_type,
      });
    }
  };

  handleFormSubmit = (e, question_paper_save_type) => {
    //console.log("madddddd", this.state, question_paper_save_type);

    // console.log("this.state.getScheduledTypesArr1",this.state.getScheduledTypesArr)

    // Re-checked here, not just at the modal: the submit is the actual write, and
    // the modal could already be open when a grant changes.
    if (!this.requireEdit()) {
      if (e && e.preventDefault) e.preventDefault();
      this.setState({ modalShow: false });
      return "";
    }

    if (this.state.exam_name == "") {
      this.setState({
        submitError1: "Please enter exam name",
      });
      return "";
    }

    if (this.state.class_id == "0" && question_paper_save_type != "Draft") {
      this.setState({
        submitError1: "Please select class",
      });
      return "";
    }

    if (
      this.state.sectionSelected.length == "0" &&
      question_paper_save_type != "Draft"
    ) {
      this.setState({
        submitError1: "Please select Section",
      });
      return "";
    }

    if (
      this.state.scheduledSubType_id == 0 &&
      question_paper_save_type != "Draft"
    ) {
      this.setState({
        submitError1: "Please select Scheduled Type",
      });
      return "";
    }

    if (this.state.startdate == "") {
      this.setState({
        submitError1: "Please select Start Time",
      });
      return "";
    }

    this.setState({
      isSubmitting: true,
    });

    e.preventDefault();

    this.setState({
      spinnerStatus: "1",
    });

    setTimeout(() => {
      let stateSyllabus = this.state.subjects;
      let syllabusArray = [];
      let qbankQuestion = [];
      let q_types_for_quesBank_insBank = [];
      let sectionsArr = [];
      let branchArr = [];
      let is_part_exam = "0",
        exam_model_id = 0,
        mains_2021 = "0";
      let schedule_type_id_value = 0,
        schedule_sub_type_id_value = 0,
        adaptive_type_id_value = 0;

      for (let i = 0; i < stateSyllabus.length; i++) {
        let idata = stateSyllabus[i];
        let totalchapters = idata.chapters;
        let topicArray = [];

        for (let x = 0; x < totalchapters.length; x++) {
          let tdata = totalchapters[x];

          if (tdata.questionbarray.length > 0) {
            tdata.questionbarray.map((questionbarraymapData) => {
              const newquestionId = questionbarraymapData;
              qbankQuestion.push(parseInt(newquestionId.id));
              q_types_for_quesBank_insBank.push(parseInt(newquestionId.qtype));
            });
          }

          let totaltopics = tdata.topics;

          for (let y = 0; y < totaltopics.length; y++) {
            let ttdata = totaltopics[y];
            //console.log("ttdata", ttdata);
            if (ttdata.checked == true) {
              let newtopic = ttdata.id;
              //console.log("newtopic", newtopic);
              topicArray.push(newtopic);
            }
          }
        }
        //console.log("topicArray", topicArray);
        const newSyllabus = {
          subject_id: parseInt(idata.id),
          chapters: [],
          topics: topicArray,
        };
        syllabusArray.push(newSyllabus);
      }

      if (question_paper_save_type == "Draft" && qbankQuestion.length == 0) {
        this.setState({
          submitError1: "Please select at least one question in any subject",
          spinnerStatus: "",
          isSubmitting: false,
        });
        return "";
      }
      //console.log("qbankQuestion", qbankQuestion);

      let newArray = syllabusArray.filter((item) => item.topics.length > 0);

      //console.log('newArray', newArray);
      let startdate = "";
      if (this.state.startdate == "") {
        startdate = moment().format("DD-MM-YYYY HH:mm:ss");
      } else {
        startdate = this.state.startdate;
      }

      let enddate = "";
      if (this.state.enddate == "") {
        enddate = moment().format("DD-MM-YYYY HH:mm:ss");
      } else {
        enddate = this.state.enddate;
      }

      let exam_type_val = "";
      let sub_exam_type_val = 0;
      exam_type_val = this.state.exam_type;

      let autogenerate = true;
      if (this.state.generate_type != "1") {
        autogenerate = false;
      }
      if (this.state.exam_type == 1) {
        if (this.state.pattern_type == 0 || this.state.pattern_type == 3) {
          exam_model_id = 0;
        } else {
          exam_model_id = 2;
        }
        mains_2021 = "0";
        sub_exam_type_val = 0;
      } else if (this.state.exam_type == 2) {
        if (this.state.pattern_type == 0) {
          mains_2021 = "0";
        } else if (this.state.pattern_type == 3) {
          mains_2021 = "3";
        } else {
          mains_2021 = "1";
        }
        exam_model_id = 0;
        sub_exam_type_val = 1;
      } else {
        exam_model_id = 0;
        mains_2021 = "0";
        sub_exam_type_val = 0;
      }

      let complexity_type = 0,
        complexity_custom_values = [];
      if (this.state.complexity_type_str == "custom") {
        complexity_type = 0;
        complexity_custom_values.push(this.state.custom_easy_val);
        complexity_custom_values.push(this.state.custom_modarate_val);
        complexity_custom_values.push(this.state.custom_difficult_val);
      } else {
        if (
          this.state.exam_type == 1 &&
          this.state.complexity_type_str == "easy"
        ) {
          complexity_type = 4;
        } else if (
          this.state.exam_type == 1 &&
          this.state.complexity_type_str == "standard"
        ) {
          complexity_type = 1;
        } else if (
          this.state.exam_type == 2 &&
          this.state.complexity_type_str == "easy"
        ) {
          complexity_type = 5;
        } else if (
          this.state.exam_type == 2 &&
          this.state.complexity_type_str == "standard"
        ) {
          complexity_type = 2;
        } else {
          complexity_type = 1;
        }
      }

      for (let i = 0; i < this.state.sectionSelected.length; i++) {
        sectionsArr.push(parseInt(this.state.sectionSelected[i]));
      }

      let branches = [...new Set(this.state.branchSelected)];
      for (let i = 0; i < branches.length; i++) {
        branchArr.push(parseInt(this.state.branchSelected[i]));
      }
      let sylabusclass = 0;
      if (this.state.exam_generate_type == "group_semi_grand") {
        sylabusclass = this.state.exam_generate_class_value;
      }

      if (this.state.scheduledSubType_id != 0) {
        const selectedScheduledTypeArr = this.state.getScheduledTypesArr.filter(
          (a) => a.value == this.state.scheduledSubType_id,
        );

        if (selectedScheduledTypeArr.length > 0) {
          schedule_type_id_value = parseInt(
            selectedScheduledTypeArr[0].schedule_type_id,
          );
          schedule_sub_type_id_value = parseInt(this.state.scheduledSubType_id);
          adaptive_type_id_value = parseInt(
            selectedScheduledTypeArr[0].adaptive_type_id,
          );
        }
      }

      let creategeneralpaper = "";
      creategeneralpaper = {
        syllabus: newArray,
        exam_name: this.state.exam_name,
        exam_type: parseInt(exam_type_val),
        exam_class_id: parseInt(sylabusclass),
        class_id: parseInt(this.state.class_id),
        exam_model_id: exam_model_id,
        mains_2021: mains_2021.toString(),
        branch: branchArr.toString(),
        section: sectionsArr.toString(),
        sub_exam_type: parseInt(sub_exam_type_val),
        no_of_sets: parseInt(this.state.noofsets),
        start_time: startdate,
        pattern_type: parseInt(this.state.pattern_type),
        end_time: enddate,
        institution_id: parseInt(Cookies.get("institutionid")),
        username: Cookies.get("username"),
        autogenerate: autogenerate,
        questionbank_questions: qbankQuestion.toString(),
        question_type: q_types_for_quesBank_insBank.toString(),
        complexity_type: complexity_type,
        complexity_custom_values: complexity_custom_values.toString(),
        type: this.state.exam_generate_type,
        exam_mode: window.location.pathname === "/exam_made_easy" ? 0 : 1,
        schedule_type_id: schedule_type_id_value,
        schedule_sub_type_id: schedule_sub_type_id_value,
        adaptive_type_id: adaptive_type_id_value,
      };
      console.log("paper", creategeneralpaper);

      const question_count = this.state.subjects.map((a) => {
        return {
          subject_id: parseInt(a.id),
          question_count: parseInt(a.qcount),
        };
      });
      console.log(
        "creategeneralpaper",
        creategeneralpaper,
        parseInt(this.state.timeduration),
        question_count,
      );

      //console.log("question_paper_save_type", question_paper_save_type)

      if (question_paper_save_type == "Save") {
        this.createExamMadeEasyPaper(
          creategeneralpaper,
          parseInt(this.state.timeduration),
          question_count,
        ).catch((error) => {
          //console.log("catch if error");
          //console.log(error);
          this.setState({
            submitError1: error.graphQLErrors.map((x) => x.message),
            spinnerStatus: "",
            isSubmitting: false,
          });
          //console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
      } else {
        this.examMadeEasyDraftPapers(
          creategeneralpaper,
          parseInt(this.state.timeduration),
          question_count,
        ).catch((error) => {
          //console.log("catch if error");
          //console.log(error);
          this.setState({
            submitError1: error.graphQLErrors.map((x) => x.message),
            spinnerStatus: "",
            isSubmitting: false,
          });
          //console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
      }
    }, 1000);
  };

  createExamMadeEasyPaper = async (params, time_duration, question_count) => {
    // Final gate before the write leaves the client.
    if (!this.requireEdit()) return;

    await this.props.createExamMadeEasyPaper({
      variables: {
        params,
        time_duration,
        question_count,
      },
      update: (store, { data }) => {
        //console.log("createGeneralPaperdata", data);
        if (data.createExamMadeEasyPaper) {
          let tcq = 0;
          let totalExamCount3 = "";

          if (
            this.state.exam_type == "3" ||
            this.state.exam_type == "6" ||
            this.state.exam_type == "7" ||
            this.state.eamcetExamType == "8"
          ) {
            this.state.subjects.map((item) => {
              tcq = tcq + item.qcount;
            });

            let eduration = this.props.globals.exams.find(
              (a) => a.id == this.state.exam_type,
            );
            //console.log("eduration", eduration);

            if (eduration != undefined) {
              totalExamCount3 =
                parseFloat(eduration.avg_question_time) * parseFloat(tcq);
            }
          }
          //console.log("tcqtotalExamCount3", tcq, totalExamCount3);
          this.setState({
            currentStep: 5,

            submitError1: "",

            filename: data.createExamMadeEasyPaper.filename,
          });
          // this.props.history.push({
          //     pathname: "/questions/manage-question-paper",
          // });
          const currentPath = window.location.pathname;

          if (currentPath === "/exam_made_easy") {
            this.props.history.push({
              pathname: "/questions/manage-question-paper",
            });
          } else if (currentPath === "/offline_exams/exam_made_easy") {
            this.props.history.push({
              pathname: "/offline_exams/manage-question-paper",
            });
          }
        }
      },
    });
  };

  examMadeEasyDraftPapers = async (params, time_duration, question_count) => {
    // Final gate before the write leaves the client.
    if (!this.requireEdit()) return;

    await this.props.examMadeEasyDraftPapers({
      variables: {
        params,
        time_duration,
        question_count,
      },
      update: (store, { data }) => {
        //console.log("createGeneralPaperdata", data);
        if (data.examMadeEasyDraftPapers) {
          let tcq = 0;
          let totalExamCount3 = "";

          if (
            this.state.exam_type == "3" ||
            this.state.exam_type == "6" ||
            this.state.exam_type == "7" ||
            this.state.eamcetExamType == "8"
          ) {
            this.state.subjects.map((item) => {
              tcq = tcq + item.qcount;
            });

            let eduration = this.props.globals.exams.find(
              (a) => a.id == this.state.exam_type,
            );
            //console.log("eduration", eduration);

            if (eduration != undefined) {
              totalExamCount3 =
                parseFloat(eduration.avg_question_time) * parseFloat(tcq);
            }
          }
          //console.log("tcqtotalExamCount3", tcq, totalExamCount3);
          this.setState({
            currentStep: 5,
            submitError1: "",
            filename: data.examMadeEasyDraftPapers.filename,
          });
          this.props.history.push({
            pathname: "/exam_made_easy/draft_question_view/DraftQuestionsView",
          });
        }
      },
    });
  };

  handleTabChange = (value) => {
    this.setState({ activeTab: value });
  };

  // "You may look, but not touch" — shown when a view-only role clicks an action.
  // One modal serves every intercepted action (create / edit / delete).
  renderAccessDeniedModal = () => (
    <Modal
      show={this.state.accessDeniedShow}
      onHide={this.hideAccessDenied}
      centered
      size="sm"
      aria-labelledby="access-denied-title"
    >
      <Modal.Body className="text-center" style={{ padding: "28px 24px" }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "#fef2f2",
            color: "#dc2626",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}
        >
          <i className="fal fa-lock-alt" style={{ fontSize: 26 }} />
        </div>
        <h5
          id="access-denied-title"
          style={{ fontWeight: 800, color: "#0f172a", marginBottom: 8 }}
        >
          Access Denied
        </h5>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 20 }}>
          You don't have permission to perform this action.
        </p>
        <Button variant="secondary" onClick={this.hideAccessDenied}>
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );

  render() {
    // is_view === 0 → no page. The route guard (moduleAccessGuard) already stops a
    // direct URL hit, but this component is also mounted from two pages, so it
    // enforces its own view grant rather than trusting the caller. The pages supply
    // the navbar/sidebar/footer, so this is a card, not the full-shell AccessDenied.
    if (!this.canViewExams()) {
      return (
        <Container fluid className="exam_made_easy">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "70vh",
              padding: 24,
            }}
          >
            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 16,
                boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
                padding: "40px 44px",
                maxWidth: 460,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: "50%",
                  background: "#fef2f2",
                  color: "#dc2626",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 18px",
                }}
              >
                <i className="fal fa-lock-alt" style={{ fontSize: 30 }} />
              </div>
              <h3
                style={{
                  fontSize: 20,
                  fontWeight: 800,
                  color: "#0f172a",
                  marginBottom: 10,
                }}
              >
                Access Denied
              </h3>
              <p
                style={{
                  fontSize: 14,
                  color: "#64748b",
                  lineHeight: 1.6,
                  marginBottom: 0,
                }}
              >
                You don't have access to this module. Please contact your
                administrator.
              </p>
            </div>
          </div>
        </Container>
      );
    }

    //console.log("exam_generate_type", this.state.exam_generate_type)
    //console.log("this.state.exam_type", this.state.exam_type)
    console.log("ddddddddddddddddddddddddddddd", this.state);

    if (this.state.exam_type == 1) {
      if (this.state.pattern_type == 0) {
        this.state.generalQuestionsCount = 44;
      } else if (this.state.pattern_type == 2) {
        this.state.generalQuestionsCount = 49;
      } else {
        this.state.generalQuestionsCount = 99;
      }
    } else if (this.state.exam_type == 2) {
      if (this.state.pattern_type == 0) {
        this.state.generalQuestionsCount = 19;
        this.state.integerQuestionCount = 4;
      } else if (this.state.pattern_type == 1) {
        this.state.generalQuestionsCount = 19;
        this.state.integerQuestionCount = 9;
      } else {
        this.state.generalQuestionsCount = 50;
        this.state.integerQuestionCount = 50;
      }
    } else if (this.state.exam_type == 3 || this.state.exam_type == 6) {
      this.state.generalQuestionsCount = 39;
    } else if (this.state.exam_type == 7 || this.state.exam_type == 8) {
      this.state.generalQuestionsCount = 39;
    } else if (
      this.state.exam_type == 9 ||
      this.state.exam_type == 10 ||
      this.state.exam_type == 11
    ) {
      this.state.generalQuestionsCount = 59;
    }

    //console.log("subjects", this.state.subjects)
    let chaptername = "Chapter";
    const chapter = this.state.subjects.map((item) => {
      if (
        item.subjectactive ==
        "d-flex justify-content-between align-items-center active"
      ) {
        item.chapters.map((chdata) => {
          if (
            chdata.chapteractive ==
            "d-flex justify-content-between align-items-center active"
          ) {
            chaptername = chdata.chapter;
          }
        });
      }
    });

    let topicselectall = true;
    let topiclabelledBy = "Select";
    let topicdisableSearch = false;
    if (this.state.getTopicsArr.length > 0) {
      topicselectall = true;
      topicdisableSearch = false;
    } else {
      topicdisableSearch = true;
      topicselectall = false;
      topiclabelledBy = "Topics";
    }

    let finddata = [];
    let newData1 = [];
    let latestData = [];

    if (this.state.getQuestionBankQuestions.length > 0) {
      this.state.getQuestionBankQuestions.map((item) => {
        this.state.subjects.map((item1) => {
          if (parseInt(item1.id) == parseInt(item.subject)) {
            item1.chapters.map((item3) => {
              const arr = item.chapter;
              //console.log("sssss", arr)
              if (arr.includes(item3.id.toString())) {
                if (item3.questionbarray.length > 0) {
                  finddata = item3.questionbarray;
                  //console.log("find", finddata);
                }
              }
            });
          }
        });
      });

      //console.log("finddatafinddatafinddatafinddata", finddata)

      if (finddata.length > 0) {
        newData1 = this.state.getQuestionBankQuestions.map((item) => {
          if (finddata.length > 0) {
            //console.log("item", item)

            if (finddata.find((a) => a.id == item.id)) {
              return { ...item, checked: true };
            } else {
              return { ...item, checked: false };
            }
          }
        });
      }

      if (newData1.length > 0) {
        latestData = newData1.filter((a) =>
          a.id.includes(this.state.qbQuestionSearchSubject),
        );
        //latestData = newData1;
      } else {
        //latestData = this.state.getQuestionBankQuestions;
        latestData = this.state.getQuestionBankQuestions.filter((a) =>
          a.id.toString().includes(this.state.qbQuestionSearchSubject),
        );
      }
      //console.log("this.state.generalCheckedgeneralChecked", this.state);
    }

    let subjectDisabled = false;
    if (
      this.state.exam_type == 9 ||
      this.state.exam_type == 10 ||
      this.state.exam_type == 11
    ) {
      console.log(
        "maheshstate",
        this.state.generalQuestionsPhysicsSelected.length > 0,
        this.state.generalQuestionsChemistrySelected.length > 0,
        this.state.generalQuestionsMathsSelected.length > 0,
        this.state.generalQuestionsBiologySelected.length > 0,
      );
      if (
        this.state.generalQuestionsPhysicsSelected.length > 0 ||
        this.state.generalQuestionsChemistrySelected.length > 0 ||
        this.state.generalQuestionsMathsSelected.length > 0 ||
        this.state.generalQuestionsBiologySelected.length > 0
      ) {
        console.log("maheshstate1");
        subjectDisabled = true;
      }
    }

    return (
      <Container fluid className="exam_made_easy">
        <div
          style={{
            background: "#f8fafc",
            border: "1.5px solid #e2e8f0",
            borderRadius: 12,
            padding: "12px 16px 0 16px",
            marginTop: 16,
          }}
        >
          <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
            {[
              { value: 1, label: "General Exam", icon: "fal fa-file-alt" },
              // { value: 2, label: "Adaptive Exam", icon: "fal fa-brain" },
              { value: 3, label: "PDF Questions", icon: "fal fa-book" },
            ].map((tab) => {
              const isActive = this.state.activeTab === tab.value;
              return (
                <li className="nav-item" key={tab.value}>
                  <a
                    className={`nav-link ${isActive ? "active" : ""}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleTabChange(tab.value);
                    }}
                    style={{
                      cursor: "pointer",
                      fontWeight: 700,
                      fontSize: 14,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "12px 20px",
                      color: isActive ? "#6366f1" : "#4b5563",
                      background: isActive ? "#fff" : "transparent",
                      borderColor: isActive
                        ? "#e2e8f0 #e2e8f0 #fff"
                        : "transparent",
                      borderWidth: "1.5px",
                      borderBottomWidth: isActive ? "2px" : "1.5px",
                      borderRadius: "10px 10px 0 0",
                      transition: "all 0.15s ease",
                      marginBottom: "-1.5px",
                    }}
                  >
                    <i className={tab.icon} />
                    {tab.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        {this.state.activeTab === 1 ? (
          <>
            <Row>
              <Col sm={12} className="text-right float-right">
                {/* Both open the create/draft workspace, so both are is_edit
                    actions: a view-only role stays here and gets Access Denied
                    rather than being redirected. */}
                <Button
                  type="button"
                  onClick={() =>
                    this.navigateIfEditAllowed(
                      "/exam_made_easy/draft_question_view/DraftQuestionsView",
                    )
                  }
                  style={{
                    background: "#3d66f5",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    padding: "10px 15px",
                    borderRadius: "8px",
                    marginLeft: "8px",
                    marginRight: "8px",
                  }}
                >
                  Show Draft Papers
                </Button>
                <Button
                  type="button"
                  onClick={() =>
                    this.navigateIfEditAllowed(
                      "/questions/create-question-paper/own-question-paper/college-exam",
                    )
                  }
                  style={{
                    background: "#3d66f5",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    padding: "10px 20px",
                    borderRadius: "8px",
                  }}
                >
                  Create College Exams
                </Button>
              </Col>
            </Row>
            <Row>
              <Col sm={9} className="mt-3">
                <Card as={Card.Body} className="block_white">
                  <Row>
                    <Col sm={3} className="mt-2">
                      <Form.Group
                        as={Col}
                        sm={12}
                        className="pad_lef_0"
                        controlId="ExamType"
                      >
                        <Form.Label className="font-weight-bold mb-1">
                          EXAM
                          <span className="errorCls">
                            {this.state.validateExamType}
                          </span>
                        </Form.Label>
                        <SelectBoxWithDisabledOption
                          stateData={this.state.exam_typeValue}
                          handleChange={this.selecthandleInputChange}
                          name="exam_type"
                          options={this.state.examTypeOptions}
                          placeholderName={"Exam Type"}
                          dropdownIndicator={{ DropdownIndicator }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={5} className="mt-2">
                      <div className="float-right">
                        <h6 className="f-16">GENERATE TYPE</h6>
                        <ul className="list-inline list_exam_type_cls1 mt-2">
                          <li>
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                id="generatetype1"
                                value="1"
                                name="generate_type"
                                className="custom-control-input"
                                defaultChecked={true}
                                onChange={(e) =>
                                  this.questionGenerateType(
                                    e,
                                    "1",
                                    "generate_type",
                                  )
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="generatetype1"
                              >
                                Auto Generate
                              </label>
                            </div>
                          </li>
                          <li>
                            <div className="custom-control custom-radio custom-control-inline">
                              <input
                                type="radio"
                                id="generatetype2"
                                value="2"
                                name="generate_type"
                                className="custom-control-input"
                                onChange={(e) =>
                                  this.questionGenerateType(
                                    e,
                                    "2",
                                    "generate_type",
                                  )
                                }
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="generatetype2"
                              >
                                Question Bank
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    {this.state.exam_type == "1" ? (
                      <Col sm={4} className="mt-2">
                        <h6 className="f-16 mb-2">PATTERN TYPE (NTA)</h6>
                        <div className="custom-control custom-radio custom-control-inline margin_right0">
                          <input
                            type="radio"
                            id="patterntype1"
                            value="0"
                            name="pattern_type"
                            className="custom-control-input"
                            defaultChecked={true}
                            onChange={this.handleInputChange}
                          />
                          <label
                            className="custom-control-label font-weight-normal"
                            htmlFor="patterntype1"
                          >
                            NTA Pattern
                          </label>
                        </div>
                        {/*<div className="custom-control custom-radio custom-control-inline margin_right0 right_pos">
                                                                <input
                                                                    type="radio"
                                                                    id="patterntype2"
                                                                    value="2"
                                                                    name="pattern_type"
                                                                    className="custom-control-input"
                                                                    defaultChecked={false}
                                                                    onChange={this.handleInputChange}
                                                                />
                                                                <label
                                                                    className="custom-control-label  font-weight-normal"
                                                                    htmlFor="patterntype2"
                                                                >
                                                                    New Pattern
                                                                </label>
                                                            </div>*/}
                        <div className="custom-control custom-radio custom-control-inline margin_right0">
                          <input
                            type="radio"
                            id="patterntype3"
                            value="3"
                            name="pattern_type"
                            className="custom-control-input"
                            defaultChecked={false}
                            onChange={this.handleInputChange}
                          />
                          <label
                            className="custom-control-label font-weight-normal"
                            htmlFor="patterntype3"
                          >
                            Custom Pattern
                          </label>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                    {this.state.exam_type == "2" ? (
                      <Col sm={4} className="mt-2">
                        <h6 className="f-16 mb-2">PATTERN TYPE (NTA)</h6>
                        <div className="custom-control custom-radio custom-control-inline margin_right0">
                          <input
                            type="radio"
                            id="patterntype1"
                            value="0"
                            name="pattern_type"
                            className="custom-control-input"
                            defaultChecked={true}
                            onChange={this.handleInputChange}
                          />
                          <label
                            className="custom-control-label font-weight-normal"
                            htmlFor="patterntype1"
                          >
                            NTA Pattern
                          </label>
                        </div>
                        {/* <div className="custom-control custom-radio custom-control-inline margin_right0 right_pos">
                                                    <input
                                                        type="radio"
                                                        id="patterntype2"
                                                        value="1"
                                                        name="pattern_type"
                                                        className="custom-control-input"
                                                        defaultChecked={false}
                                                        onChange={this.handleInputChange}
                                                    />
                                                    <label
                                                        className="custom-control-label  font-weight-normal"
                                                        htmlFor="patterntype2"
                                                    >
                                                        New Pattern
                                                    </label>
                                                </div> */}
                        <div className="custom-control custom-radio custom-control-inline margin_right0">
                          <input
                            type="radio"
                            id="patterntype3"
                            value="3"
                            name="pattern_type"
                            className="custom-control-input"
                            defaultChecked={false}
                            onChange={this.handleInputChange}
                          />
                          <label
                            className="custom-control-label font-weight-normal"
                            htmlFor="patterntype3"
                          >
                            Custom Pattern
                          </label>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>

                  {/* 
                            <Row>

                                {
                                    this.state.exam_type == "3" || this.state.exam_type == "6" || this.state.exam_type == "7" || this.state.exam_type == "8" || this.state.pattern_type == "3" ?
                                        (
                                            <Col sm={6}>
                                                <Form.Group as={Col} sm={12} controlId="eamcetExamType">
                                                    <Form.Label className="font-weight-bold">MAX QUESTION TIME (Sec/Q) </Form.Label>
                                                    <Form.Control
                                                        style={{ width: 150 }}
                                                        type="text"
                                                        placeholder="duration"
                                                        name="timeduration"
                                                        onChange={this.handleInputChange}
                                                        autoComplete="off"
                                                        value={this.state.timeduration}
                                                    />
                                                    <Form.Text className="form-text text-danger">
                                                        {this.state.formErrors.timeduration}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )
                                        :
                                        ("")
                                }

                            </Row> */}
                  {this.state.generate_type == "1" ? (
                    <>
                      <Row>
                        <Col sm={12}>
                          <h6 className="f-16 mt-2">COMPLEXITY TYPE</h6>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={4} className="mt-2">
                          <Card className="card_shadow">
                            <Card.Header className="card_header text-center">
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="complexType_easy"
                                  value="easy"
                                  name="complexity_type_str"
                                  className="custom-control-input"
                                  defaultChecked={true}
                                  onChange={(e) =>
                                    this.complexityType("easy", "complexity")
                                  }
                                />
                                <label
                                  className="custom-control-label font-weight-bold"
                                  htmlFor="complexType_easy"
                                >
                                  EASY
                                </label>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-1 mt-2">
                              <Row>
                                <Col sm={3}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Easy
                                  </h6>
                                  <h6 className="text-center mt-3 f-14 font-weight-normal">
                                    {this.state.easy_easy}%
                                  </h6>
                                </Col>
                                <Col sm={5}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Moderate
                                  </h6>
                                  <h6 className="text-center mt-3 f-14 font-weight-normal">
                                    {this.state.easy_Modarate}%
                                  </h6>
                                </Col>
                                <Col sm={4}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Difficult
                                  </h6>
                                  <h6 className="text-center mt-3 f-14 font-weight-normal">
                                    {this.state.easy_block_Difficult}%
                                  </h6>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>
                        <Col sm={4} className="mt-2">
                          <Card className="card_shadow">
                            <Card.Header className="card_header text-center">
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="complexType_standard"
                                  value="standard"
                                  name="complexity_type_str"
                                  className="custom-control-input"
                                  defaultChecked={false}
                                  onChange={(e) =>
                                    this.complexityType(
                                      "standard",
                                      "complexity",
                                    )
                                  }
                                />
                                <label
                                  className="custom-control-label font-weight-bold"
                                  htmlFor="complexType_standard"
                                >
                                  STANDARD
                                </label>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-1 mt-2">
                              <Row>
                                <Col sm={3}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Easy
                                  </h6>
                                  <h6 className="text-center mt-3 f-14 font-weight-normal">
                                    {this.state.standard_easy}%
                                  </h6>
                                </Col>
                                <Col sm={5}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Moderate
                                  </h6>
                                  <h6 className="text-center mt-3 f-14 font-weight-normal">
                                    {this.state.standard_block_Modarate}%
                                  </h6>
                                </Col>
                                <Col sm={4}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Difficult
                                  </h6>
                                  <h6 className="text-center mt-3 f-14 font-weight-normal">
                                    {this.state.standard_block_Difficult}%
                                  </h6>
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>

                        <Col sm={4} className="mt-2">
                          <Card className="card_shadow">
                            <Card.Header className="card_header text-center">
                              <div className="custom-control custom-radio custom-control-inline">
                                <input
                                  type="radio"
                                  id="complexType_custom"
                                  value="custom"
                                  name="complexity_type_str"
                                  className="custom-control-input"
                                  defaultChecked={false}
                                  onChange={(e) =>
                                    this.complexityType("custom", "complexity")
                                  }
                                />
                                <label
                                  className="custom-control-label font-weight-bold"
                                  htmlFor="complexType_custom"
                                >
                                  CUSTOM
                                </label>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-1 mt-2">
                              <Row>
                                <Col sm={4}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Easy
                                  </h6>
                                  <Form.Control
                                    type="number"
                                    placeholder=""
                                    name="custom_easy_val"
                                    autoComplete="off"
                                    className="custom_selection"
                                    onChange={this.handleInputChange}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <h6 className="text-center f-12 font-weight-normal">
                                    Moderate
                                  </h6>
                                  <Form.Control
                                    type="number"
                                    placeholder=""
                                    name="custom_modarate_val"
                                    autoComplete="off"
                                    className="custom_selection"
                                    onChange={this.handleInputChange}
                                  />
                                </Col>
                                <Col sm={4}>
                                  <h6 className="text-center f-14 font-weight-normal">
                                    Difficult
                                  </h6>
                                  <Form.Control
                                    type="number"
                                    placeholder=""
                                    name="custom_difficult_val"
                                    autoComplete="off"
                                    className="custom_selection"
                                    onChange={this.handleInputChange}
                                  />
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                          <label className="errorCls">
                            {this.state.validateCustomInputValues}
                          </label>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {((this.state.generate_type == "1" &&
                    this.state.pattern_type != "3") ||
                    (this.state.generate_type == "1" &&
                      this.state.pattern_type == "3" &&
                      this.state.exam_type != "1" &&
                      this.state.exam_type != "2")) &&
                    this.state.exam_type != 9 &&
                    this.state.exam_type != 10 &&
                    this.state.exam_type != 11 ? (
                    <>
                      <Row>
                        <Col sm={7}>
                          <Row className="mt-2">
                            <Col sm={5}>
                              <Form.Label className="font-weight-bold mt-2">
                                CHANGE EXAM TYPE:
                              </Form.Label>
                            </Col>
                            <Col sm={6}>
                              <SelectBoxWithDisabledOption
                                stateData={this.state.exam_generate_type_value}
                                handleChange={this.selecthandleInputChange}
                                name="exam_generate_type"
                                options={this.state.getGenerateTypes}
                                placeholderName={"Exam Type"}
                                dropdownIndicator={{ DropdownIndicator }}
                              />
                            </Col>
                            <Col sm={12}>
                              {this.state.exam_generate_type ==
                                "group_custom" ? (
                                <p className="mt-2">
                                  Complete control to choose the syllabus.
                                </p>
                              ) : this.state.exam_generate_type ==
                                "group_semi_grand" ? (
                                <p className="mt-2">
                                  Complete syllabus of Class XI or Class XII.
                                </p>
                              ) : (
                                <p className="mt-2">
                                  Complete syllabus of Class XI and Class XII.
                                </p>
                              )}
                            </Col>
                          </Row>
                        </Col>
                        <Col sm={3}>
                          {this.state.exam_generate_type ==
                            "group_semi_grand" ? (
                            <Form.Group
                              className="mb-4 mt-3"
                              controlId="formCategory"
                            >
                              <Form.Label className="font-weight-bold f-16">
                                SYLLABUS&nbsp;SELECTION&nbsp;:&nbsp;
                              </Form.Label>
                            </Form.Group>
                          ) : (
                            ""
                          )}
                        </Col>
                        <Col sm={3}>
                          {this.state.exam_generate_type ==
                            "group_semi_grand" ? (
                            <Form.Group
                              className="mb-4 mt-2"
                              controlId="formCategory"
                            >
                              <SelectBoxWithDisabledOption
                                stateData={this.state.exam_generate_class}
                                handleChange={this.selecthandleInputChange}
                                name="exam_generate_class_value"
                                options={this.getClassData()}
                                placeholderName={"Syllabus"}
                                dropdownIndicator={{ DropdownIndicator }}
                              />
                            </Form.Group>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                </Card>
                {this.state.generate_type == "1" ? (
                  <>
                    {this.state.exam_generate_type == "group_custom" ? (
                      <>
                        <h6 className="text-uppercase mt-3">
                          Syllabus - Selection
                        </h6>
                        <Card
                          as={Card.Body}
                          className="block_white custom_setup p-2"
                        >
                          <Card.Header className="bg-white">
                            <Row className="align-items-center">
                              <Col
                                xl={4}
                                lg={4}
                                md={6}
                                sm={12}
                                xs={12}
                                className="my-2 d-flex align-items-center"
                              >
                                <div className="mr-2">Class:</div>
                                <ButtonGroup aria-label="Basic example">
                                  {this.state.classData.map((classmapData) => (
                                    <Button
                                      onClick={(e) =>
                                        this.syllabusClassFun(
                                          e,
                                          classmapData.id,
                                        )
                                      }
                                      variant={classmapData.active}
                                    >
                                      {classmapData.class}
                                    </Button>
                                  ))}

                                  {/* <Button variant="outline-secondary">XII-2</Button> */}
                                </ButtonGroup>
                              </Col>
                            </Row>
                          </Card.Header>
                          <Card.Body>
                            <Row noGutters={true} className="mb-4">
                              <Card as={Col} xl={2} lg={2} md={12}>
                                <Card.Header className="bg-white">
                                  <Card.Title className="mb-0 h6">
                                    Subjects{" "}
                                  </Card.Title>
                                </Card.Header>
                                <Card.Body className="p-2">
                                  <Scrollbars
                                    style={{ height: 160 }}
                                    {...this.props}
                                    renderThumbVertical={renderThumb}
                                    autoHide
                                    autoHideTimeout={500}
                                    autoHideDuration={200}
                                  >
                                    <ul className="list-unstyled subject-list m-0">
                                      {this.state.subjects.map(
                                        (subjectmapData) => {
                                          let anyOneSubjectChecked =
                                            this.state.subjects.some(
                                              (item) => item.checked,
                                            );
                                          console.log(
                                            "anyOneSubjectChecked",
                                            anyOneSubjectChecked,
                                          );
                                          if (
                                            anyOneSubjectChecked &&
                                            (this.state.exam_type == 9 ||
                                              this.state.exam_type == 10 ||
                                              this.state.exam_type == 11)
                                          ) {
                                            return (
                                              <>
                                                <li
                                                  className={
                                                    !subjectmapData.checked
                                                      ? `${subjectmapData.subjectactive} toolTip1`
                                                      : `${subjectmapData.subjectactive}`
                                                  }
                                                  onClick={(e) =>
                                                    this.subjectFunction(
                                                      subjectmapData.id,
                                                    )
                                                  }
                                                >
                                                  <div className="subName">
                                                    {subjectmapData.subject}{" "}
                                                    <span className="tooltiptext">
                                                      U can select only one
                                                      subject
                                                    </span>
                                                  </div>
                                                  <div className="arrow">
                                                    <i className="fal fa-arrow-right" />
                                                  </div>
                                                </li>
                                              </>
                                            );
                                          } else {
                                            return (
                                              <>
                                                <li
                                                  className={
                                                    subjectmapData.subjectactive
                                                  }
                                                  onClick={(e) =>
                                                    this.subjectFunction(
                                                      subjectmapData.id,
                                                    )
                                                  }
                                                >
                                                  <div className="subName">
                                                    {subjectmapData.subject}
                                                  </div>
                                                  <div className="arrow">
                                                    <i className="fal fa-arrow-right" />
                                                  </div>
                                                </li>
                                              </>
                                            );
                                          }
                                        },
                                      )}
                                    </ul>
                                  </Scrollbars>
                                </Card.Body>
                              </Card>
                              {this.state.exam_type == "3" ||
                                this.state.exam_type == "6" ||
                                this.state.exam_type == "7" ||
                                this.state.exam_type == "8" ||
                                this.state.pattern_type == "3" ? (
                                <Card as={Col} xl={2} lg={2} md={12}>
                                  <Card.Header className="bg-white">
                                    <Card.Title className="mb-0 h6">
                                      Q's Count
                                    </Card.Title>
                                  </Card.Header>
                                  <Card.Body className="p-2">
                                    <Scrollbars
                                      style={{ height: 160 }}
                                      {...this.props}
                                      renderThumbVertical={renderThumb}
                                      autoHide
                                      autoHideTimeout={500}
                                      autoHideDuration={200}
                                    >
                                      <Form>
                                        {this.state.subjects.map((item) => (
                                          <div>
                                            {item.subjectactive ==
                                              "d-flex justify-content-between align-items-center active" ? (
                                              <div>
                                                <Form.Text className="form-text text-danger">
                                                  {/* {item.totpererr} */}
                                                </Form.Text>
                                                <Form.Group
                                                  as={Row}
                                                  controlId="formChapter1"
                                                >
                                                  {/* <Form.Label column sm="7"> Count  </Form.Label> */}
                                                  <Col sm="12">
                                                    <Form.Control
                                                      value={item.qcount}
                                                      type="text"
                                                      name="percentage"
                                                      placeholder=""
                                                      autoComplete="off"
                                                      onChange={(e) =>
                                                        this.squestioncount(
                                                          e,
                                                          item.id,
                                                        )
                                                      }
                                                      maxLength="2"
                                                    />
                                                    <Form.Text className="form-text text-danger">
                                                      {item.totError}
                                                    </Form.Text>
                                                  </Col>
                                                </Form.Group>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        ))}
                                      </Form>
                                    </Scrollbars>
                                  </Card.Body>
                                </Card>
                              ) : (
                                ""
                              )}

                              <Card as={Col} xl={4} lg={4} md={12}>
                                <Card.Header className="bg-white">
                                  <Card.Title className="mb-0 h6">
                                    Chapters
                                  </Card.Title>
                                </Card.Header>
                                <Card.Body className="p-2">
                                  <Scrollbars
                                    style={{ height: 160 }}
                                    {...this.props}
                                    renderThumbVertical={renderThumb}
                                    autoHide
                                    autoHideTimeout={500}
                                    autoHideDuration={200}
                                  >
                                    <ul className="list-unstyled chapter-list m-0">
                                      {this.state.subjects.map(
                                        (subjectmapData) => {
                                          let mchaptermapData = [];
                                          if (
                                            subjectmapData.subjectactive ==
                                            "d-flex justify-content-between align-items-center active"
                                          ) {
                                            if (
                                              this.state.syllabusclass != "0"
                                            ) {
                                              //console.log("this.state.syllabusclass", this.state.syllabusclass);
                                              mchaptermapData =
                                                subjectmapData.chapters.filter(
                                                  (a) =>
                                                    a.class ==
                                                    this.state.syllabusclass,
                                                );
                                              //console.log("filter", mchaptermapData);
                                            } else {
                                              mchaptermapData =
                                                subjectmapData.chapters;
                                              //console.log("filter2", mchaptermapData);
                                            }
                                          }

                                          return (
                                            <React.Fragment>
                                              {subjectmapData.subjectactive ==
                                                "d-flex justify-content-between align-items-center active" ? (
                                                <React.Fragment>
                                                  {mchaptermapData.map(
                                                    (chaptermapData) => {
                                                      return (
                                                        <li
                                                          className={
                                                            chaptermapData.chapteractive
                                                          }
                                                          onClick={(e) =>
                                                            this.chapterFunction(
                                                              subjectmapData.id,
                                                              chaptermapData.id,
                                                            )
                                                          }
                                                        >
                                                          <div className="names">
                                                            {
                                                              chaptermapData.chapter
                                                            }
                                                          </div>
                                                          <div className="counts">
                                                            (
                                                            {
                                                              chaptermapData
                                                                .topics.length
                                                            }
                                                            )
                                                          </div>
                                                        </li>
                                                      );
                                                    },
                                                  )}
                                                </React.Fragment>
                                              ) : (
                                                ""
                                              )}
                                            </React.Fragment>
                                          );
                                        },
                                      )}
                                    </ul>
                                  </Scrollbars>
                                </Card.Body>
                              </Card>
                              <Card
                                as={Col}
                                xl={
                                  this.state.exam_type == "3" ||
                                    this.state.exam_type == "6" ||
                                    this.state.exam_type == "7" ||
                                    this.state.exam_type == "8" ||
                                    this.state.pattern_type == "3"
                                    ? 4
                                    : 6
                                }
                                lg={
                                  this.state.exam_type == "3" ||
                                    this.state.exam_type == "6" ||
                                    this.state.exam_type == "7" ||
                                    this.state.exam_type == "8"
                                    ? 4
                                    : 6
                                }
                                md={12}
                              >
                                <Card.Header className="bg-white">
                                  <Card.Title className="mb-0 h6">
                                    {chaptername} - Topic
                                  </Card.Title>
                                </Card.Header>
                                <Card.Body className="p-2">
                                  <Scrollbars
                                    style={{ height: 160 }}
                                    {...this.props}
                                    renderThumbVertical={renderThumb}
                                    autoHide
                                    autoHideTimeout={500}
                                    autoHideDuration={200}
                                  >
                                    <ul className="list-unstyled chap-topic-list m-0 pl-1">
                                      {this.state.subjects.map(
                                        (subjectmapData) => (
                                          <React.Fragment>
                                            {subjectmapData.subjectactive ==
                                              "d-flex justify-content-between align-items-center active" ? (
                                              <React.Fragment>
                                                {subjectmapData.chapters.map(
                                                  (chaptermapData) => (
                                                    <React.Fragment>
                                                      {chaptermapData.chapteractive ==
                                                        "d-flex justify-content-between align-items-center active" ? (
                                                        <React.Fragment>
                                                          {chaptermapData.topics.map(
                                                            (
                                                              topicmapData,
                                                              index,
                                                            ) => (
                                                              <React.Fragment>
                                                                {index ==
                                                                  "0" ? (
                                                                  <React.Fragment>
                                                                    <li>
                                                                      <Form.Check
                                                                        type="checkbox"
                                                                        id="checkboxAll"
                                                                        custom
                                                                      >
                                                                        <Form.Check.Input
                                                                          checked={
                                                                            chaptermapData.checkedall
                                                                          }
                                                                          type="checkbox"
                                                                          onClick={(
                                                                            e,
                                                                          ) =>
                                                                            this.topiccheckallFunction(
                                                                              e,
                                                                              subjectmapData.id,
                                                                              chaptermapData.id,
                                                                            )
                                                                          }
                                                                        />
                                                                        <Form.Check.Label htmlFor="checkboxAll">
                                                                          Select
                                                                          All
                                                                        </Form.Check.Label>
                                                                      </Form.Check>
                                                                    </li>
                                                                    <li>
                                                                      <Form.Check
                                                                        type="checkbox"
                                                                        id={
                                                                          "checkboxOne" +
                                                                          index
                                                                        }
                                                                        custom
                                                                      >
                                                                        <Form.Check.Input
                                                                          checked={
                                                                            topicmapData.checked
                                                                          }
                                                                          type="checkbox"
                                                                          onClick={(
                                                                            e,
                                                                          ) =>
                                                                            this.topicFunction(
                                                                              e,
                                                                              subjectmapData.id,
                                                                              chaptermapData.id,
                                                                              topicmapData.id,
                                                                            )
                                                                          }
                                                                        />
                                                                        <Form.Check.Label
                                                                          htmlFor={
                                                                            "checkboxOne" +
                                                                            index
                                                                          }
                                                                        >
                                                                          {
                                                                            topicmapData.topic
                                                                          }
                                                                        </Form.Check.Label>
                                                                      </Form.Check>
                                                                    </li>
                                                                  </React.Fragment>
                                                                ) : (
                                                                  <li>
                                                                    <Form.Check
                                                                      type="checkbox"
                                                                      id={
                                                                        "checkboxOne" +
                                                                        index
                                                                      }
                                                                      custom
                                                                    >
                                                                      <Form.Check.Input
                                                                        checked={
                                                                          topicmapData.checked
                                                                        }
                                                                        type="checkbox"
                                                                        onClick={(
                                                                          e,
                                                                        ) =>
                                                                          this.topicFunction(
                                                                            e,
                                                                            subjectmapData.id,
                                                                            chaptermapData.id,
                                                                            topicmapData.id,
                                                                          )
                                                                        }
                                                                      />
                                                                      <Form.Check.Label
                                                                        htmlFor={
                                                                          "checkboxOne" +
                                                                          index
                                                                        }
                                                                      >
                                                                        {
                                                                          topicmapData.topic
                                                                        }
                                                                      </Form.Check.Label>
                                                                    </Form.Check>
                                                                  </li>
                                                                )}
                                                              </React.Fragment>
                                                            ),
                                                          )}
                                                        </React.Fragment>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </React.Fragment>
                                                  ),
                                                )}
                                              </React.Fragment>
                                            ) : (
                                              ""
                                            )}
                                          </React.Fragment>
                                        ),
                                      )}
                                    </ul>
                                  </Scrollbars>
                                </Card.Body>
                              </Card>
                            </Row>
                          </Card.Body>
                        </Card>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  <>
                    <h6 className="text-uppercase mt-4">
                      Question Bank Questions
                    </h6>
                    <Card as={Card.Body} className="block_white custom_setup">
                      {this.state.generate_type == "2" ? (
                        <>
                          <h6 className="mt-3">
                            Subject Wise Questions Selected:{" "}
                          </h6>
                          <div className="table-responsive your_css_class_here">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Subject</th>
                                  <th>General Questions</th>
                                  {this.state.exam_type == 2 ? (
                                    <th>Integer Questions</th>
                                  ) : (
                                    ""
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.subjects.map((item) => (
                                  <tr>
                                    <td>{item.subject}</td>
                                    {item.id == 1 ? (
                                      <>
                                        <td>
                                          {
                                            this.state
                                              .generalQuestionsBotanySelected
                                              .length
                                          }
                                          {this.state.exam_type == 1 ? (
                                            <>
                                              {this.state.pattern_type == 0 ? (
                                                this.state
                                                  .generalQuestionsBotanySelected
                                                  .length > 44 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )
                                              ) : this.state
                                                .generalQuestionsBotanySelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : this.state.exam_type == 2 ? (
                                            this.state
                                              .generalQuestionsBotanySelected
                                              .length > 19 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state
                                            .generalQuestionsBotanySelected
                                            .length > 39 ? (
                                            <span className="red_color ml-3">
                                              (Maximum Questions Reached)
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </>
                                    ) : item.id == 2 ? (
                                      <>
                                        <td>
                                          {
                                            this.state
                                              .generalQuestionsPhysicsSelected
                                              .length
                                          }
                                          {this.state.exam_type == 1 ? (
                                            <>
                                              {this.state.pattern_type == 0 ? (
                                                this.state
                                                  .generalQuestionsPhysicsSelected
                                                  .length > 44 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )
                                              ) : this.state
                                                .generalQuestionsPhysicsSelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : this.state.exam_type == 2 ? (
                                            this.state.pattern_type == 3 ? (
                                              this.state
                                                .generalQuestionsPhysicsSelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )
                                            ) : this.state
                                              .generalQuestionsPhysicsSelected
                                              .length > 19 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state.exam_type == 9 ||
                                            this.state.exam_type == 10 ||
                                            this.state.exam_type == 11 ? (
                                            this.state
                                              .generalQuestionsPhysicsSelected
                                              .length > 59 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state
                                            .generalQuestionsPhysicsSelected
                                            .length > 39 ? (
                                            <span className="red_color ml-3">
                                              (Maximum Questions Reached)
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </>
                                    ) : item.id == 3 ? (
                                      <>
                                        <td>
                                          {
                                            this.state
                                              .generalQuestionsChemistrySelected
                                              .length
                                          }
                                          {this.state.exam_type == 1 ? (
                                            <>
                                              {this.state.pattern_type == 0 ? (
                                                this.state
                                                  .generalQuestionsChemistrySelected
                                                  .length > 44 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )
                                              ) : this.state
                                                .generalQuestionsChemistrySelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : this.state.exam_type == 2 ? (
                                            this.state.pattern_type == 3 ? (
                                              this.state
                                                .generalQuestionsChemistrySelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )
                                            ) : this.state
                                              .generalQuestionsChemistrySelected
                                              .length > 19 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state.exam_type == 9 ||
                                            this.state.exam_type == 10 ||
                                            this.state.exam_type == 11 ? (
                                            this.state
                                              .generalQuestionsChemistrySelected >
                                              59 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state
                                            .generalQuestionsChemistrySelected
                                            .length > 39 ? (
                                            <span className="red_color ml-3">
                                              (Maximum Questions Reached)
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </>
                                    ) : item.id == 4 ? (
                                      <>
                                        <td>
                                          {
                                            this.state
                                              .generalQuestionsMathsSelected
                                              .length
                                          }
                                          {this.state.examtype == 1 ? (
                                            <>
                                              {this.state.pattern_type == 0 ? (
                                                this.state
                                                  .generalQuestionsMathsSelected
                                                  .length > 44 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )
                                              ) : this.state.pattern_type ==
                                                1 ? (
                                                this.state
                                                  .generalQuestionsMathsSelected
                                                  .length > 49 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )
                                              ) : this.state
                                                .generalQuestionsMathsSelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : this.state.exam_type == 2 ? (
                                            this.state.pattern_type == 3 ? (
                                              this.state
                                                .generalQuestionsMathsSelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )
                                            ) : this.state
                                              .generalQuestionsMathsSelected
                                              .length > 19 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state.exam_type == 9 ||
                                            this.state.exam_type == 10 ||
                                            this.state.exam_type == 11 ? (
                                            this.state
                                              .generalQuestionsMathsSelected
                                              .length > 59 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state
                                            .generalQuestionsMathsSelected
                                            .length > 79 ? (
                                            <span className="red_color ml-3">
                                              (Maximum Questions Reached)
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </>
                                    ) : item.id == 5 ? (
                                      <>
                                        <td>
                                          {
                                            this.state
                                              .generalQuestionsZoologySelected
                                              .length
                                          }
                                          {this.state.exam_type == 1 ? (
                                            <>
                                              {this.state.pattern_type == 0 ? (
                                                this.state
                                                  .generalQuestionsZoologySelected
                                                  .length > 44 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )
                                              ) : this.state
                                                .generalQuestionsZoologySelected
                                                .length > 49 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : this.state.exam_type == 2 ? (
                                            this.state
                                              .generalQuestionsZoologySelected
                                              .length > 19 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )
                                          ) : this.state
                                            .generalQuestionsZoologySelected
                                            .length > 39 ? (
                                            <span className="red_color ml-3">
                                              (Maximum Questions Reached)
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td>
                                          {
                                            this.state
                                              .generalQuestionsBiologySelected
                                              .length
                                          }

                                          {this.state
                                            .generalQuestionsBiologySelected
                                            .length > 59 ? (
                                            <span className="red_color ml-3">
                                              (Maximum Questions Reached)
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                      </>
                                    )}

                                    {/* Integer questions */}

                                    {this.state.exam_type == 2 ? (
                                      <>
                                        {item.id == 1 ? (
                                          <td>
                                            {
                                              this.state
                                                .integerQuestionsBotanySelected
                                                .length
                                            }
                                            {this.state.pattern_type == 0 ? (
                                              this.state
                                                .integerQuestionsBotanySelected
                                                .length > 4 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )
                                            ) : this.state.pattern_type == 1 ? (
                                              this.state
                                                .integerQuestionsBotanySelected
                                                .length > 9 ? (
                                                <span className="red_color ml-3">
                                                  (Maximum Questions Reached)
                                                </span>
                                              ) : (
                                                ""
                                              )
                                            ) : this.state
                                              .integerQuestionsBotanySelected
                                              .length > 49 ? (
                                              <span className="red_color ml-3">
                                                (Maximum Questions Reached)
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                        ) : (
                                          <>
                                            {item.id == 5 ? (
                                              <td>
                                                {
                                                  this.state
                                                    .integerQuestionsZoologySelected
                                                    .length
                                                }
                                                {this.state.pattern_type ==
                                                  0 ? (
                                                  this.state
                                                    .integerQuestionsZoologySelected
                                                    .length > 4 ? (
                                                    <span className="red_color ml-3">
                                                      (Maximum Questions
                                                      Reached)
                                                    </span>
                                                  ) : (
                                                    ""
                                                  )
                                                ) : this.state.pattern_type ==
                                                  1 ? (
                                                  this.state
                                                    .integerQuestionsZoologySelected
                                                    .length > 9 ? (
                                                    <span className="red_color ml-3">
                                                      (Maximum Questions
                                                      Reached)
                                                    </span>
                                                  ) : (
                                                    ""
                                                  )
                                                ) : this.state
                                                  .integerQuestionsZoologySelected
                                                  .length > 49 ? (
                                                  <span className="red_color ml-3">
                                                    (Maximum Questions Reached)
                                                  </span>
                                                ) : (
                                                  ""
                                                )}
                                              </td>
                                            ) : (
                                              <>
                                                {item.id == 2 ? (
                                                  <td>
                                                    {
                                                      this.state
                                                        .integerQuestionsPhysicsSelected
                                                        .length
                                                    }
                                                    {this.state.pattern_type ==
                                                      0 ? (
                                                      this.state
                                                        .integerQuestionsPhysicsSelected
                                                        .length > 4 ? (
                                                        <span className="red_color ml-3">
                                                          (Maximum Questions
                                                          Reached)
                                                        </span>
                                                      ) : (
                                                        ""
                                                      )
                                                    ) : this.state
                                                      .pattern_type == 1 ? (
                                                      this.state
                                                        .integerQuestionsPhysicsSelected
                                                        .length > 9 ? (
                                                        <span className="red_color ml-3">
                                                          (Maximum Questions
                                                          Reached)
                                                        </span>
                                                      ) : (
                                                        ""
                                                      )
                                                    ) : this.state
                                                      .integerQuestionsPhysicsSelected
                                                      .length > 49 ? (
                                                      <span className="red_color ml-3">
                                                        (Maximum Questions
                                                        Reached)
                                                      </span>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </td>
                                                ) : (
                                                  <>
                                                    {item.id == 4 ? (
                                                      <td>
                                                        {
                                                          this.state
                                                            .integerQuestionsMathsSelected
                                                            .length
                                                        }
                                                        {this.state
                                                          .pattern_type == 0 ? (
                                                          this.state
                                                            .integerQuestionsMathsSelected
                                                            .length > 4 ? (
                                                            <span className="red_color ml-3">
                                                              (Maximum Questions
                                                              Reached)
                                                            </span>
                                                          ) : (
                                                            ""
                                                          )
                                                        ) : this.state
                                                          .pattern_type ==
                                                          1 ? (
                                                          this.state
                                                            .integerQuestionsMathsSelected
                                                            .length > 9 ? (
                                                            <span className="red_color ml-3">
                                                              (Maximum Questions
                                                              Reached)
                                                            </span>
                                                          ) : (
                                                            ""
                                                          )
                                                        ) : this.state
                                                          .integerQuestionsMathsSelected
                                                          .length > 49 ? (
                                                          <span className="red_color ml-3">
                                                            (Maximum Questions
                                                            Reached)
                                                          </span>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </td>
                                                    ) : (
                                                      <>
                                                        {item.id == 3 ? (
                                                          <td>
                                                            {
                                                              this.state
                                                                .integerQuestionsChemistrySelected
                                                                .length
                                                            }
                                                            {this.state
                                                              .pattern_type ==
                                                              0 ? (
                                                              this.state
                                                                .integerQuestionsChemistrySelected
                                                                .length > 4 ? (
                                                                <span className="red_color ml-3">
                                                                  (Maximum
                                                                  Questions
                                                                  Reached)
                                                                </span>
                                                              ) : (
                                                                ""
                                                              )
                                                            ) : this.state
                                                              .pattern_type ==
                                                              1 ? (
                                                              this.state
                                                                .integerQuestionsChemistrySelected
                                                                .length > 9 ? (
                                                                <span className="red_color ml-3">
                                                                  (Maximum
                                                                  Questions
                                                                  Reached)
                                                                </span>
                                                              ) : (
                                                                ""
                                                              )
                                                            ) : this.state
                                                              .integerQuestionsChemistrySelected
                                                              .length > 49 ? (
                                                              <span className="red_color ml-3">
                                                                (Maximum
                                                                Questions
                                                                Reached)
                                                              </span>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </td>
                                                        ) : (
                                                          ""
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                      <Row className="align-items-center">
                        <Col
                          xl={4}
                          lg={4}
                          md={6}
                          sm={12}
                          xs={12}
                          className="my-2 d-flex align-items-center"
                        >
                          <div className="mr-2">Class:</div>
                          <ButtonGroup aria-label="Basic example">
                            {this.state.classData.map((classmapData) => (
                              <Button
                                onClick={(e) =>
                                  this.ownedquestionClassFun1(
                                    e,
                                    classmapData.id,
                                  )
                                }
                                variant={classmapData.active}
                              >
                                {classmapData.class}
                              </Button>
                            ))}

                            {/* <Button variant="outline-secondary">XII-2</Button> */}
                          </ButtonGroup>
                        </Col>
                      </Row>
                      <hr />
                      <Form>
                        <Row>
                          <Col>
                            {subjectDisabled ? (
                              <p style={{ color: "red" }}>
                                *U can select only one subject
                              </p>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Form.Group
                            as={Col}
                            xl={3}
                            lg={3}
                            md={6}
                            sm={12}
                            controlId="slectSubject"
                          >
                            <Form.Label className="font-weight-bold">
                              Subject{" "}
                              <span className="errorCls">
                                {this.state.validateSubject}
                              </span>
                            </Form.Label>
                            <SelectBoxWithDisabledOption
                              stateData={this.state.qbsearchsubjectvalue}
                              handleChange={this.selecthandleInputChange}
                              name="qbsearchsubject"
                              options={this.state.subjectOptions}
                              placeholderName={"Subject"}
                              dropdownIndicator={{ DropdownIndicator }}
                              isDisabled={subjectDisabled}
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            xl={4}
                            lg={4}
                            md={6}
                            sm={12}
                            controlId="SelectChapters"
                          >
                            <Form.Label className="font-weight-bold">
                              Chapter{" "}
                              <span className="errorCls">
                                {this.state.validateChapter}
                              </span>
                            </Form.Label>
                            <SelectBoxWithDisabledOption
                              stateData={this.state.qbsearchchaptervalue}
                              handleChange={this.selecthandleInputChange}
                              name="qbsearchchapter"
                              options={this.state.getChaptersArr}
                              placeholderName={"Chapters"}
                              dropdownIndicator={{ DropdownIndicator }}
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            xl={4}
                            lg={4}
                            md={6}
                            sm={12}
                            controlId="SelectTopics"
                          >
                            <Form.Label className="font-weight-bold">
                              Topic{" "}
                              <span className="errorCls">
                                {this.state.validateTopic}
                              </span>
                            </Form.Label>
                            <MultiSelect
                              overrideStrings={{
                                allItemsAreSelected: "All Topics are selected.",
                                selectSomeItems: topiclabelledBy,
                              }}
                              disableSearch={topicdisableSearch}
                              hasSelectAll={topicselectall}
                              options={this.state.getTopicsArr}
                              value={this.state.qbsearchtopicvalue}
                              onChange={(e) =>
                                this.handleMultipleSelectInputChange(e, "topic")
                              }
                              labelledBy={"Topics"}
                            />
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            xl={3}
                            lg={3}
                            md={6}
                            sm={12}
                            controlId="SelectType"
                          >
                            <Form.Label className="font-weight-bold">
                              Type of Questions{" "}
                            </Form.Label>
                            <SelectBoxWithDisabledOption
                              stateData={this.state.typeOfQuestionvalue}
                              handleChange={this.selecthandleInputChange}
                              name="typeOfQuestion"
                              options={this.state.getTypeOfQuestionsArr}
                              placeholderName={"Type of Questions"}
                              dropdownIndicator={{ DropdownIndicator }}
                            />
                            <span className="errorCls">
                              {this.state.validateTypeOfQuestion}
                            </span>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            xl={3}
                            lg={3}
                            md={6}
                            sm={12}
                            controlId="SelectComplexity"
                          >
                            <Form.Label className="font-weight-bold">
                              Complexity{" "}
                            </Form.Label>
                            <SelectBoxWithDisabledOption
                              stateData={this.state.complexityvalue}
                              handleChange={this.selecthandleInputChange}
                              name="complexity"
                              options={this.state.getComplexityValueArr}
                              placeholderName={"Complexity"}
                              dropdownIndicator={{ DropdownIndicator }}
                            />
                            <span className="errorCls">
                              {this.state.validateComplexity}
                            </span>
                          </Form.Group>
                          <Form.Group as={Col} xl={6} lg={6} md={6} sm={12}>
                            <Button
                              type="button"
                              className="btn btn-light-blue float-right mt-2rem"
                              onClick={(e) => this.onScrollgetQuestionById(1)}
                            >
                              Get Questions
                            </Button>
                          </Form.Group>
                        </Row>
                      </Form>

                      {this.state.getQuestionBankQuestions == "" ? (
                        <Row>
                          <Col
                            sm={12}
                            className={
                              this.state.showSpinner == "show"
                                ? "showSpinnerCls text-center"
                                : "hideSpinnerCls text-center"
                            }
                          >
                            <div class="spinner-border text-primary text-center loading-img-center"></div>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                      {latestData != "" ? (
                        <>
                          {/* <Row>
                                                                <Col sm={12}>
                                                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="quentionSearch" className='float-right'>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="quesionsearch"
                                                                            value={this.state.quesionsearch}
                                                                            onChange={this.quentionSearchhandleChange}
                                                                            placeholder="Question Search"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row> */}
                          <div className="mt-1">
                            <CardLessDataTable
                              parentData={this.questionsTable(latestData)}
                              particlecolumns={this.colFunction}
                              searchBar={false}
                            />
                          </div>

                          <div></div>
                        </>
                      ) : this.state.showQuestionsNotAvailable == "no" ? (
                        <h6 className="text-center mt-2 mb-2">
                          Questions Not Available....
                        </h6>
                      ) : (
                        ""
                      )}
                    </Card>
                  </>
                )}
              </Col>
              <Col sm={3} className="mt-3">
                <div className="aside_bar">
                  <Row>
                    <Col sm={12}>
                      <Card as={Card.Body} className="block_white">
                        <QuestionSelectedDetails
                          stateData={this.state}
                          globals={this.props.globals}
                          showQuestionGenerateModal={
                            this.showQuestionGenerateModal
                          }
                        />
                      </Card>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <ExamMadeEasyModal
                  stateData={this.state}
                  parentpdatefunction={this.datefunction}
                  parentpdatefunctionend={this.datefunctionend}
                  ParenthandleFormSubmit={this.handleFormSubmit}
                  show={this.state.modalShow}
                  onHide={() =>
                    this.setState({
                      modalShow: false,
                      submitError1: "",
                      startdate: "",
                      enddate: "",
                      add3Hours_val: "",
                    })
                  }
                  globals={this.props.globals}
                  phandleInputChange={this.handleInputChange}
                  pselecthandleInputChange={this.selecthandleInputChange}
                  handleMultipleSelectInputChange={
                    this.handleMultipleSelectInputChange
                  }
                />
              </Col>
            </Row>
          </>
        ) : this.state.activeTab === 2 ? (
          // Unreachable while the "Adaptive Exam" tab above is commented out (activeTab is
          // only ever set from that tab list). Kept so re-enabling is a one-line uncomment.
          <>
            <AdaptiveExams type="creation" />
          </>
        ) : this.state.activeTab === 3 ? (
          <>
            <PdfTabs />
          </>
        ) : null}

        {/* Outside the tab switch so an intercepted action shows it on any tab. */}
        {this.renderAccessDeniedModal()}
      </Container>
    );
  }
}

export default withRouter(
  withApollo(
    compose(
      graphql(GROUPEXAMMADEEASY_PAPER, {
        name: "createExamMadeEasyPaper",
      }),
      graphql(GROUPEXAMMADEEASY_DRAFT_PAPER, {
        name: "examMadeEasyDraftPapers",
      }),
    )(CreateExamMadeEasy),
  ),
);
